(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["golf-club-valuation"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGolfValuationSection(root) {
      var sid = root.getAttribute('data-gcv-sid');
      if (!sid) return;

      var form = document.getElementById('GolfValuation-' + sid);
      if (!form || !root.contains(form)) return;

      form.setAttribute('novalidate', 'novalidate');
      form.noValidate = true;

    var TOTAL_STEPS = 6;
    var currentStep = 0;
    var loftBuiltForType = null;

    var wizard = document.getElementById('gcv-wizard-' + sid);
    var steps = wizard ? wizard.querySelectorAll('[data-gcv-step]') : [];
    var progressEl = document.getElementById('gcv-progress-' + sid);
    var backBtn = document.getElementById('gcv-back-' + sid);
    var nextBtn = document.getElementById('gcv-next-' + sid);
    var submitBtn = document.getElementById('gcv-submit-' + sid);

    var typeEl = document.getElementById('gcv-type-' + sid);
    var typePicker = document.getElementById('gcv-type-picker-' + sid);
    var typeOptions = typePicker ? typePicker.querySelectorAll('[data-gcv-type-value]') : [];
    var brandSelect = document.getElementById('gcv-brand-select-' + sid);
    var brandCustomWrap = document.getElementById('gcv-brand-custom-wrap-' + sid);
    var brandCustom = document.getElementById('gcv-brand-custom-' + sid);
    var modelSelectWrap = document.getElementById('gcv-model-select-wrap-' + sid);
    var modelSelect = document.getElementById('gcv-model-select-' + sid);
    var modelCustomWrap = document.getElementById('gcv-model-custom-wrap-' + sid);
    var modelCustom = document.getElementById('gcv-model-custom-' + sid);
    var shaftEl = document.getElementById('gcv-shaft-' + sid);
    var flexEl = document.getElementById('gcv-flex-' + sid);
    var shaftFieldWrap = document.getElementById('gcv-shaft-field-' + sid);
    var flexFieldWrap = document.getElementById('gcv-flex-field-' + sid);
    var loftFieldWrap = document.getElementById('gcv-loft-field-' + sid);
    var loftSelect = document.getElementById('gcv-loft-select-' + sid);
    var loftCustom = document.getElementById('gcv-loft-custom-' + sid);
    var loftCustomWrap = document.getElementById('gcv-loft-custom-wrap-' + sid);
    var loftLabelEl = document.getElementById('gcv-loft-label-' + sid);
    var conditionEl = document.getElementById('gcv-condition-' + sid);
    var handednessEl = document.getElementById('gcv-handedness-' + sid);
    var headcoverEl = document.getElementById('gcv-headcover-' + sid);
    var headcoverFieldWrap = document.getElementById('gcv-headcover-field-' + sid);
    var nameEl = document.getElementById('gcv-name-' + sid);
    var emailEl = document.getElementById('gcv-email-' + sid);
    var phoneEl = document.getElementById('gcv-phone-' + sid);
    var bodyHidden = document.getElementById('gcv-body-hidden-' + sid);
    var photosWrap = document.getElementById('gcv-photos-' + sid);
    var photosInput = document.getElementById('gcv-photos-input-' + sid);
    var photosPreview = document.getElementById('gcv-photos-preview-' + sid);
    var photosError = document.getElementById('gcv-photos-error-' + sid);
    var photosHiddenWrap = document.getElementById('gcv-photos-hidden-' + sid);
    var payoutWrap = document.getElementById('gcv-payout-' + sid);
    var payoutErrorEl = document.getElementById('gcv-payout-error-' + sid);
    var payoutSwishWrap = document.getElementById('gcv-payout-swish-wrap-' + sid);
    var payoutBankWrap = document.getElementById('gcv-payout-bank-wrap-' + sid);
    var payoutSwishPhone = document.getElementById('gcv-payout-swish-phone-' + sid);
    var payoutClearing = document.getElementById('gcv-payout-clearing-' + sid);
    var payoutAccount = document.getElementById('gcv-payout-account-' + sid);
    var aiEstimateEl = document.getElementById('gcv-ai-estimate-' + sid);
    var shippingEl = document.getElementById('gcv-shipping-' + sid);
    var shippingTitleEl = document.getElementById('gcv-shipping-title-' + sid);
    var shippingBodyEl = document.getElementById('gcv-shipping-body-' + sid);
    var clubsCartWrap = document.getElementById('gcv-clubs-cart-' + sid);
    var clubsSummaryEl = document.getElementById('gcv-clubs-summary-' + sid);
    var clubsCartCountEl = document.getElementById('gcv-clubs-cart-count-' + sid);
    var clubsCartTotalEl = document.getElementById('gcv-clubs-cart-total-' + sid);
    var clubsCartHintEl = document.getElementById('gcv-clubs-cart-hint-' + sid);
    var addClubWrap = document.getElementById('gcv-add-club-' + sid);
    var addClubHintEl = document.getElementById('gcv-add-club-hint-' + sid);
    var addClubBtn = document.getElementById('gcv-add-club-btn-' + sid);
    var finishClubsWrap = document.getElementById('gcv-finish-clubs-' + sid);
    var finishClubsBtn = document.getElementById('gcv-finish-clubs-btn-' + sid);
    var submitLabelDefault = submitBtn ? submitBtn.textContent : '';
    var savedClubs = [];
    var checkoutFinalized = false;
    var STORE_CREDIT_BONUS = 0.2;
    var FREE_SHIPPING_THRESHOLD = 1000;
    var SHIPPING_COST = 49;

    function getSavedClubsGrossSum() {
      return savedClubs.reduce(function (sum, club) {
        return sum + (club.grossPrice || 0);
      }, 0);
    }

    function getCurrentClubGrossPrice() {
      var price = form.dataset.gcvAiPrice;
      return price ? parseFloat(price) : 0;
    }

    function getTotalGrossPrice() {
      return Math.round(getSavedClubsGrossSum() + getCurrentClubGrossPrice());
    }

    function getNetOfferPrice(basePrice) {
      var price = Number(basePrice);
      if (!Number.isFinite(price)) return 0;
      if (price >= FREE_SHIPPING_THRESHOLD) return Math.round(price);
      return Math.max(0, Math.round(price - SHIPPING_COST));
    }

    function hasFreeShipping(basePrice) {
      return Number(basePrice) >= FREE_SHIPPING_THRESHOLD;
    }

    function formatSek(amount) {
      return new Intl.NumberFormat('sv-SE', {
        style: 'currency',
        currency: 'SEK',
        maximumFractionDigits: 0
      }).format(amount);
    }

    function getSelectedPayout() {
      if (!payoutWrap) return null;
      var checked = payoutWrap.querySelector('input[type="radio"]:checked');
      if (!checked) return null;
      return {
        value: checked.value,
        label: checked.getAttribute('data-payout-label') || checked.value
      };
    }

    function syncPayoutSelectionState() {
      var payout = getSelectedPayout();
      if (payout) {
        form.dataset.gcvPayoutValue = payout.value;
        form.dataset.gcvPayoutMethod = payout.label;
      } else {
        delete form.dataset.gcvPayoutValue;
        delete form.dataset.gcvPayoutMethod;
      }
      return payout;
    }

    function isStoreCreditPayout() {
      if (form.dataset.gcvPayoutValue === 'store_credit') return true;
      var payout = getSelectedPayout();
      return !!(payout && payout.value === 'store_credit');
    }

    function needsCheckoutFinalize() {
      return savedClubs.length > 0 && !checkoutFinalized;
    }

    function isCheckoutReady() {
      return !!form.dataset.gcvAiPrice && !needsCheckoutFinalize();
    }

    function requiresPayoutChoice() {
      return root.dataset.gcvAiEnabled === 'true' && isCheckoutReady();
    }

    function isCashPayout(value) {
      return value === 'swish' || value === 'bank_transfer';
    }

    function isValidSwishPhone(value) {
      var digits = (value || '').replace(/\D/g, '');
      if (digits.indexOf('46') === 0) digits = '0' + digits.slice(2);
      return /^07\d{8}$/.test(digits);
    }

    function isValidClearing(value) {
      return /^\d{4,5}$/.test((value || '').replace(/\s/g, ''));
    }

    function isValidAccountNumber(value) {
      return /^\d{6,12}$/.test((value || '').replace(/\s/g, ''));
    }

    function syncPayoutDetailsUi() {
      var selected = getSelectedPayout();
      if (selected && selected.value !== 'swish' && payoutSwishPhone) {
        payoutSwishPhone.value = '';
        if (typeof markFieldError === 'function') markFieldError(payoutSwishPhone, false);
      }
      if (selected && selected.value !== 'bank_transfer') {
        if (payoutClearing) {
          payoutClearing.value = '';
          if (typeof markFieldError === 'function') markFieldError(payoutClearing, false);
        }
        if (payoutAccount) {
          payoutAccount.value = '';
          if (typeof markFieldError === 'function') markFieldError(payoutAccount, false);
        }
      }
    }

    function validatePayoutDetails(markErrors) {
      var selected = getSelectedPayout();
      if (!selected) return false;
      var valid = true;

      if (selected.value === 'swish') {
        var phoneOk = isValidSwishPhone(payoutSwishPhone ? payoutSwishPhone.value : '');
        if (markErrors) markFieldError(payoutSwishPhone, !phoneOk);
        if (!phoneOk) valid = false;
      }

      if (selected.value === 'bank_transfer') {
        var clearingOk = isValidClearing(payoutClearing ? payoutClearing.value : '');
        var accountOk = isValidAccountNumber(payoutAccount ? payoutAccount.value : '');
        if (markErrors) markFieldError(payoutClearing, !clearingOk);
        if (markErrors) markFieldError(payoutAccount, !accountOk);
        if (!clearingOk || !accountOk) valid = false;
      }

      return valid;
    }

    function highlightPayoutOffers() {
      if (!aiEstimateEl) return;
      var cashOffer = aiEstimateEl.querySelector('.golf-valuation__ai-offer--cash');
      var creditOffer = aiEstimateEl.querySelector('.golf-valuation__ai-offer--credit');
      var selected = getSelectedPayout();
      if (cashOffer) {
        cashOffer.classList.toggle('is-selected', !!(selected && isCashPayout(selected.value)));
      }
      if (creditOffer) {
        creditOffer.classList.toggle('is-selected', !!(selected && selected.value === 'store_credit'));
      }
    }

    function getStoreCreditTotal(totalGross) {
      var total = Number(totalGross);
      if (!Number.isFinite(total) || total <= 0) return 0;
      return Math.round(getNetOfferPrice(total) * (1 + STORE_CREDIT_BONUS));
    }

    function getClubCartDisplayPrice(grossPrice, totalGross, clubIndex, clubCount, useCredit) {
      var gross = Number(grossPrice);
      if (!Number.isFinite(gross) || gross <= 0) return 0;
      if (!useCredit) return Math.round(gross);

      var total = Number(totalGross);
      if (!Number.isFinite(total) || total <= 0) {
        return Math.round(getNetOfferPrice(gross) * (1 + STORE_CREDIT_BONUS));
      }

      var totalCredit = getStoreCreditTotal(total);
      if (clubCount <= 1) return totalCredit;

      if (clubIndex === clubCount - 1) {
        var allocated = 0;
        for (var i = 0; i < clubCount - 1; i++) {
          allocated += Math.round(totalCredit * (getClubGrossAtCartIndex(i) / total));
        }
        return Math.max(0, totalCredit - allocated);
      }

      return Math.round(totalCredit * (gross / total));
    }

    function getClubGrossAtCartIndex(index) {
      var savedCount = savedClubs.length;
      if (index < savedCount) return savedClubs[index].grossPrice || 0;
      return getCurrentClubGrossPrice();
    }

    function getCartClubCount(hasSaved, showCurrent) {
      return savedClubs.length + (showCurrent ? 1 : 0);
    }

    function updatePayoutBonusHint() {
      highlightPayoutOffers();
      renderClubsCart();
    }

    function onPayoutMethodChange() {
      markPayoutError(false);
      syncPayoutDetailsUi();
      syncPayoutSelectionState();
      updatePayoutBonusHint();
    }

    function selectPayoutMethod(value) {
      if (!payoutWrap || !value) return false;
      var radio = payoutWrap.querySelector('input[type="radio"][value="' + value + '"]');
      if (!radio) return false;
      radio.checked = true;
      onPayoutMethodChange();
      return true;
    }

    function updateAddClubUi(totalGross) {
      if (!addClubWrap) return;
      addClubWrap.hidden = !form.dataset.gcvAiPrice;
      if (!addClubHintEl) return;
      var total = Number(totalGross);
      if (Number.isFinite(total) && total > 0 && !hasFreeShipping(total)) {
        addClubHintEl.textContent =
          'Lägg till fler klubbor för att nå gratis frakt (över 1 000 kr).';
      } else {
        addClubHintEl.textContent = 'Lägg till fler klubbor i samma förfrågan.';
      }
    }

    function hideAddClubUi() {
      if (addClubWrap) addClubWrap.hidden = true;
    }

    function updateAiOfferPrices(totalGross) {
      if (!aiEstimateEl || !form.dataset.gcvAiPrice) return;
      var total = Number(totalGross);
      if (!Number.isFinite(total) || total <= 0) return;
      var netPrice = getNetOfferPrice(total);
      var isFree = hasFreeShipping(total);
      var creditPrice = Math.round(netPrice * (1 + STORE_CREDIT_BONUS));
      var clubCount = savedClubs.length + 1;
      var isMulti = savedClubs.length > 0;
      var cashOffer = aiEstimateEl.querySelector('.golf-valuation__ai-offer--cash');
      var creditOffer = aiEstimateEl.querySelector('.golf-valuation__ai-offer--credit');
      if (cashOffer) {
        var cashLabelEl = cashOffer.querySelector('.golf-valuation__ai-offer-label');
        var cashPriceEl = cashOffer.querySelector('.golf-valuation__ai-offer-price');
        var cashDescEl = cashOffer.querySelector('.golf-valuation__ai-offer-desc');
        if (cashLabelEl) {
          cashLabelEl.textContent = isMulti ? 'Utbetalning (totalt)' : 'Utbetalning';
        }
        if (cashPriceEl) cashPriceEl.textContent = 'Cirka ' + formatSek(netPrice);
        if (cashDescEl) {
          if (isMulti) {
            cashDescEl.textContent = isFree
              ? 'Totalt för ' + clubCount + ' klubbor — gratis frakt'
              : '49 kr har dragits av för frakt (totalt)';
          } else {
            cashDescEl.textContent = isFree
              ? 'Swish eller banköverföring — välj nedan'
              : '49 kr har dragits av för frakt';
          }
        }
      }
      if (creditOffer) {
        var creditLabelEl = creditOffer.querySelector('.golf-valuation__ai-offer-label');
        var creditPriceEl = creditOffer.querySelector('.golf-valuation__ai-offer-price');
        var creditDescEl = creditOffer.querySelector('.golf-valuation__ai-offer-desc');
        if (creditLabelEl) {
          creditLabelEl.textContent = isMulti
            ? 'Butikskredit · 20% bonus (totalt)'
            : 'Butikskredit · 20% bonus';
        }
        if (creditPriceEl) creditPriceEl.textContent = 'Cirka ' + formatSek(creditPrice);
        if (creditDescEl) {
          creditDescEl.textContent = isMulti
            ? 'Att handla för i butiken — ' + clubCount + ' klubbor'
            : 'Att handla för i butiken';
        }
      }
      form.dataset.gcvTotalGross = String(total);
      form.dataset.gcvNetPrice = String(netPrice);
      if (isFree) {
        delete form.dataset.gcvShippingDeduction;
      } else {
        form.dataset.gcvShippingDeduction = String(SHIPPING_COST);
      }
    }

    function refreshCombinedTotals() {
      var total = getTotalGrossPrice();
      if (!total) return;
      updateShippingInfo(total);
      updateAddClubUi(total);
      updateAiOfferPrices(total);
      renderClubsCart();
      syncCheckoutUi();
    }

    function syncCheckoutUi() {
      var hasEstimate = !!form.dataset.gcvAiPrice;
      var finalizeNeeded = needsCheckoutFinalize();

      if (finishClubsWrap) {
        finishClubsWrap.hidden = !hasEstimate || !finalizeNeeded;
      }

      if (payoutWrap) {
        payoutWrap.hidden = !hasEstimate || finalizeNeeded;
      }

      if (submitBtn && currentStep === TOTAL_STEPS - 1) {
        if (!hasEstimate) {
          submitBtn.hidden = false;
          submitBtn.textContent = submitLabelDefault;
        } else if (finalizeNeeded) {
          submitBtn.hidden = true;
        } else {
          submitBtn.hidden = false;
          submitBtn.textContent =
            savedClubs.length > 0 ? 'Slutför och skicka in alla klubbor' : 'Slutför och skicka in';
        }
      }

      if (hasEstimate && aiEstimateEl) {
        aiEstimateEl.hidden = false;
        var hintEl = aiEstimateEl.querySelector('.golf-valuation__ai-hint');
        if (hintEl) {
          hintEl.textContent = finalizeNeeded
            ? 'Lägg till fler klubbor eller klicka «Klart med alla klubbor» för att välja utbetalning.'
            : 'Välj utbetalningsmetod nedan och klicka sedan «Slutför och skicka in».';
        }
      }
    }

    function finalizeCheckout() {
      checkoutFinalized = true;
      syncCheckoutUi();
      refreshCombinedTotals();
      updatePayoutBonusHint();
      if (payoutWrap) {
        payoutWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function appendClubSummaryRow(label, price, isCurrent) {
      var li = document.createElement('li');
      if (isCurrent) li.className = 'is-current';
      var labelEl = document.createElement('span');
      labelEl.className = 'golf-valuation__clubs-summary-label';
      labelEl.textContent = label;
      var priceEl = document.createElement('span');
      priceEl.className = 'golf-valuation__clubs-summary-price';
      priceEl.textContent = formatSek(price);
      li.appendChild(labelEl);
      li.appendChild(priceEl);
      clubsSummaryEl.appendChild(li);
    }

    function renderClubsCart() {
      if (!clubsSummaryEl || !clubsCartWrap) return;
      clubsSummaryEl.innerHTML = '';

      var hasSaved = savedClubs.length > 0;
      var currentGross = getCurrentClubGrossPrice();
      var onFinalStep = currentStep === TOTAL_STEPS - 1;
      var showCurrent = onFinalStep && currentGross > 0 && !!form.dataset.gcvAiPrice;

      if (!hasSaved && !showCurrent) {
        clubsCartWrap.hidden = true;
        if (clubsCartTotalEl) clubsCartTotalEl.hidden = true;
        if (clubsCartHintEl) clubsCartHintEl.hidden = true;
        return;
      }

      clubsCartWrap.hidden = false;

      var clubCount = getCartClubCount(hasSaved, showCurrent);
      var totalGross = getTotalGrossPrice();
      var useCredit = isStoreCreditPayout();
      var cartTitleEl = clubsCartWrap ? clubsCartWrap.querySelector('.golf-valuation__clubs-cart-title') : null;
      if (clubsCartWrap) {
        clubsCartWrap.classList.toggle('golf-valuation__clubs-cart--credit', useCredit);
      }
      if (cartTitleEl) {
        cartTitleEl.textContent = useCredit ? 'Dina klubbor · butikskredit' : 'Dina klubbor';
      }

      savedClubs.forEach(function (club, index) {
        appendClubSummaryRow(
          index + 1 + '. ' + club.label,
          getClubCartDisplayPrice(club.grossPrice, totalGross, index, clubCount, useCredit),
          false
        );
      });

      if (showCurrent) {
        appendClubSummaryRow(
          getClubShortLabel(),
          getClubCartDisplayPrice(currentGross, totalGross, savedClubs.length, clubCount, useCredit),
          true
        );
      }

      if (clubsCartCountEl) {
        var count = savedClubs.length + (showCurrent ? 1 : 0);
        if (count > 0) {
          clubsCartCountEl.textContent = count + ' st';
        } else {
          clubsCartCountEl.textContent = '';
        }
      }

      var total = useCredit ? getStoreCreditTotal(totalGross) : totalGross;
      if (clubsCartTotalEl) {
        if (total > 0 && (hasSaved || showCurrent)) {
          clubsCartTotalEl.hidden = false;
          clubsCartTotalEl.textContent = useCredit
            ? 'Totalt butikskredit: ' + formatSek(total)
            : 'Totalt: ' + formatSek(total);
        } else {
          clubsCartTotalEl.hidden = true;
          clubsCartTotalEl.textContent = '';
        }
      }

      if (clubsCartHintEl) {
        if (hasSaved && !onFinalStep) {
          clubsCartHintEl.hidden = false;
          clubsCartHintEl.textContent =
            'Fortsätt nedan för att värdera nästa klubba. Alla klubbor säljs tillsammans i slutet.';
        } else if (hasSaved && onFinalStep && !showCurrent) {
          clubsCartHintEl.hidden = false;
          clubsCartHintEl.textContent =
            'Fyll i uppgifter och bilder för nästa klubba. Alla klubbor skickas in tillsammans.';
        } else if (hasSaved && showCurrent) {
          clubsCartHintEl.hidden = false;
          clubsCartHintEl.textContent = needsCheckoutFinalize()
            ? 'Klicka «Klart med alla klubbor» när du lagt till alla klubbor.'
            : useCredit
              ? 'Priserna visar butikskredit med 20% bonus.'
              : 'Välj utbetalning nedan för att sälja alla ' + (savedClubs.length + 1) + ' klubbor tillsammans.';
        } else if (showCurrent && useCredit) {
          clubsCartHintEl.hidden = false;
          clubsCartHintEl.textContent = 'Priserna visar butikskredit med 20% bonus.';
        } else {
          clubsCartHintEl.hidden = true;
          clubsCartHintEl.textContent = '';
        }
      }
    }

    function updateProgressLabel(stepIndex) {
      if (!progressEl) return;
      var text = 'Steg ' + (stepIndex + 1) + ' av ' + TOTAL_STEPS;
      if (savedClubs.length > 0) {
        text +=
          ' · ' +
          savedClubs.length +
          ' klubb' +
          (savedClubs.length === 1 ? 'a' : 'or') +
          ' sparad' +
          (savedClubs.length === 1 ? '' : 'e');
      }
      progressEl.textContent = text;
    }

    function updateShippingInfo(basePrice) {
      if (!shippingEl || !shippingTitleEl) return;
      var price = Number(basePrice);
      if (!Number.isFinite(price)) return;
      var isFree = hasFreeShipping(price);
      shippingEl.hidden = false;
      shippingEl.classList.toggle('golf-valuation__shipping--free', isFree);
      if (isFree) {
        shippingTitleEl.textContent = 'Gratis frakt';
        if (shippingBodyEl) {
          shippingBodyEl.textContent =
            'Du får en QR-kod att visa hos ombud. Vi skickar med DSV.';
        }
        form.dataset.gcvShippingInfo = 'Gratis frakt';
        delete form.dataset.gcvShippingDeduction;
      } else {
        shippingTitleEl.textContent = 'Frakt tillkommer';
        if (shippingBodyEl) {
          shippingBodyEl.textContent =
            '49 kr dras av från utbetalningen p.g.a. frakt. Du får en QR-kod att visa hos ombud. Vi skickar med DSV.';
        }
        form.dataset.gcvShippingInfo = 'Frakt tillkommer — 49 kr avdrag';
        form.dataset.gcvShippingDeduction = String(SHIPPING_COST);
      }
      form.dataset.gcvNetPrice = String(getNetOfferPrice(price));
    }

    function hideShippingInfo() {
      if (!shippingEl || !shippingTitleEl) return;
      shippingEl.hidden = true;
      shippingEl.classList.remove('golf-valuation__shipping--free');
      shippingTitleEl.textContent = '';
      if (shippingBodyEl) {
        shippingBodyEl.textContent = 'Du får en QR-kod att visa hos ombud. Vi skickar med DSV.';
      }
      hideAddClubUi();
      delete form.dataset.gcvShippingInfo;
      delete form.dataset.gcvShippingDeduction;
      delete form.dataset.gcvNetPrice;
      delete form.dataset.gcvTotalGross;
    }

    function showPayoutSection(basePrice) {
      if (savedClubs.length === 0) {
        checkoutFinalized = true;
      }
      refreshCombinedTotals();
      syncCheckoutUi();
      if (payoutWrap) payoutWrap.dataset.gcvBasePrice = String(basePrice);
      updatePayoutBonusHint();
    }

    function hidePayoutSection() {
      checkoutFinalized = false;
      if (!payoutWrap) return;
      payoutWrap.hidden = true;
      delete payoutWrap.dataset.gcvBasePrice;
      payoutWrap.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.checked = false;
      });
      if (payoutSwishPhone) payoutSwishPhone.value = '';
      if (payoutClearing) payoutClearing.value = '';
      if (payoutAccount) payoutAccount.value = '';
      markPayoutError(false);
      highlightPayoutOffers();
      hideShippingInfo();
      delete form.dataset.gcvPayoutMethod;
      delete form.dataset.gcvPayoutValue;
      if (finishClubsWrap) finishClubsWrap.hidden = true;
      syncCheckoutUi();
      if (submitBtn) submitBtn.textContent = submitLabelDefault;
    }

    function markPayoutError(hasError) {
      if (payoutWrap) payoutWrap.classList.toggle('golf-valuation__payout--error', hasError);
      if (payoutErrorEl) {
        payoutErrorEl.hidden = !hasError;
        payoutErrorEl.textContent = hasError ? 'Välj utbetalningsmetod.' : '';
      }
    }

    document.addEventListener('gcv-estimate-ready', function (e) {
      if (!e.detail || e.detail.sid !== sid) return;
      showPayoutSection(e.detail.pris);
    });

    document.addEventListener('gcv-estimate-reset', function (e) {
      if (!e.detail || e.detail.sid !== sid) return;
      hidePayoutSection();
      renderClubsCart();
    });

    if (payoutWrap) {
      payoutWrap.addEventListener('change', function (e) {
        onPayoutMethodChange();
        var payout = getSelectedPayout();
        if (e.target && e.target.matches && e.target.matches('input[type="radio"]')) {
          requestAnimationFrame(function () {
            if (payout && payout.value === 'swish' && payoutSwishPhone) {
              payoutSwishPhone.focus();
            } else if (payout && payout.value === 'bank_transfer' && payoutClearing) {
              payoutClearing.focus();
            }
          });
        }
      });
      payoutWrap.addEventListener('input', function (e) {
        if (e.target && e.target.matches && e.target.matches('input[type="radio"]')) {
          onPayoutMethodChange();
        }
      });
      payoutWrap.addEventListener('click', function (e) {
        var option = e.target.closest('.golf-valuation__payout-option');
        if (!option || !payoutWrap.contains(option)) return;
        var radio = option.querySelector('input[type="radio"]');
        if (!radio) return;
        if (!radio.checked) {
          radio.checked = true;
          onPayoutMethodChange();
        }
        requestAnimationFrame(function () {
          if (radio.value === 'swish' && payoutSwishPhone) {
            payoutSwishPhone.focus();
          } else if (radio.value === 'bank_transfer' && payoutClearing) {
            payoutClearing.focus();
          }
        });
      });
      payoutWrap.addEventListener('input', function (e) {
        if (!e.target) return;
        if (
          e.target === payoutSwishPhone ||
          e.target === payoutClearing ||
          e.target === payoutAccount
        ) {
          markFieldError(e.target, false);
        }
      });
    }

    if (aiEstimateEl) {
      aiEstimateEl.addEventListener('click', function (e) {
        if (!payoutWrap || payoutWrap.hidden) return;
        if (e.target.closest('.golf-valuation__ai-offer--credit')) {
          selectPayoutMethod('store_credit');
        } else if (e.target.closest('.golf-valuation__ai-offer--cash')) {
          var swishRadio = payoutWrap.querySelector('input[type="radio"][value="swish"]');
          if (swishRadio && !swishRadio.checked) {
            selectPayoutMethod('swish');
          } else if (!getSelectedPayout()) {
            selectPayoutMethod('swish');
          } else {
            onPayoutMethodChange();
          }
        }
      });
    }

    var minPhotos = 0;
    var maxPhotos = 5;
    var maxPhotoBytes = 8 * 1024 * 1024;
    if (root.dataset.gcvMinPhotos) {
      var minp = parseInt(root.dataset.gcvMinPhotos, 10);
      if (!isNaN(minp) && minp >= 0 && minp <= 5) minPhotos = minp;
    }
    if (root.dataset.gcvMaxPhotos) {
      var mp = parseInt(root.dataset.gcvMaxPhotos, 10);
      if (!isNaN(mp) && mp >= minPhotos && mp <= 8) maxPhotos = mp;
    }
    if (root.dataset.gcvMaxPhotoMb) {
      var mm = parseFloat(root.dataset.gcvMaxPhotoMb, 10);
      if (!isNaN(mm) && mm >= 1 && mm <= 20) maxPhotoBytes = Math.round(mm * 1024 * 1024);
    }
    var cloudinaryCloud = root.dataset.gcvCloudinaryCloud || '';
    var cloudinaryPreset = root.dataset.gcvCloudinaryPreset || '';

    var pendingPhotos = [];
    var photoIdSeq = 0;
    var isSubmitting = false;

    /* Modeller per märke + klubbtyp */
    var MODELS_BY_BRAND_AND_TYPE = {
      TaylorMade: {
        driver: [
          'Qi35', 'Qi35 Max', 'Qi35 Tour', 'Qi35 LS', 'Qi10', 'Qi10 Max', 'Qi10 Tour', 'Qi10 LS',
          'Stealth 2', 'Stealth 2 Plus', 'Stealth 2 HD', 'Stealth', 'Stealth Plus', 'Stealth HD',
          'SIM2', 'SIM2 Max', 'SIM2 Draw', 'SIM', 'SIM Max', 'SIM Max D', 'SIM Titanium',
          'M5', 'M5 Tour', 'M6', 'M6 D-Type', 'M3', 'M4', 'M1 2017', 'M2 2017', 'M1', 'M2', 'M2 Tour',
          'AeroBurner', 'AeroBurner TP', 'AeroBurner Mini', 'R15', 'R15 Black', 'JetSpeed', 'JetSpeed TP',
          'SLDR', 'SLDR S', 'SLDR 430', 'SLDR Mini', 'RBZ Stage 2', 'RocketBallz', 'RocketBallz Tour',
          'Burner SuperFast 2.0', 'Burner SuperFast', 'Burner 2007', 'Burner', 'r7', 'r5 Dual', 'BRNR Mini', 'Original One Mini',
          'Kalea Premier', 'Kalea', 'Kalea Gold'
        ],
        fairway: [
          'Qi35', 'Qi35 Max', 'Qi35 Tour', 'Qi10', 'Qi10 Max', 'Qi10 Tour',
          'Stealth 2', 'Stealth 2 Plus', 'Stealth', 'Stealth Plus',
          'SIM2', 'SIM2 Max', 'SIM2 Titanium', 'SIM', 'SIM Max', 'SIM Titanium',
          'M5', 'M6', 'M3', 'M4', 'M1', 'M2', 'AeroBurner', 'R15', 'JetSpeed', 'SLDR', 'SLDR S',
          'RBZ Stage 2', 'RocketBallz', 'Burner SuperFast', 'Rescue TP', 'Kalea Premier', 'Kalea'
        ],
        hybrid: [
          'Qi35 Rescue', 'Qi35 Max Rescue', 'Qi10 Rescue', 'Qi10 Max Rescue',
          'Stealth 2 Rescue', 'Stealth Rescue', 'SIM2 Rescue', 'SIM2 Max Rescue', 'SIM Rescue', 'SIM Max Rescue',
          'M6 Rescue', 'M5 Rescue', 'M3 Rescue', 'M4 Rescue', 'M1 Rescue', 'M2 Rescue',
          'AeroBurner Rescue', 'R15 Rescue', 'JetSpeed Rescue', 'SLDR Rescue', 'RBZ Stage 2 Rescue',
          'RocketBallz Rescue', 'Rescue Mid', 'Rescue Dual', 'Kalea Rescue'
        ],
        iron: [
          'P790 2023', 'P790 2021', 'P790 2019', 'P790 2017',
          'P770 2023', 'P770 2020',
          'P7MC 2023', 'P7MC 2020',
          'P7MB 2023', 'P7MB 2020',
          'P7TW',
          'Stealth HD', 'Qi Iron', 'Qi HL', 'PSi', 'PSi Tour', 'RSi 1', 'RSi 2', 'RSi TP',
          'SpeedBlade', 'SpeedBlade HL', 'RocketBladez', 'RocketBladez Tour', 'Tour Preferred MC', 'Tour Preferred MB', 'Tour Preferred CB',
          'MCGB', 'M1 Irons', 'M2 Irons', 'M3 Irons', 'M4 Irons', 'M5 Irons', 'M6 Irons',
          'Burner 2.0', 'Burner Plus', 'r7 TP', 'RAC LT', 'RAC OS', 'Kalea Gold'
        ],
        wedge: [
          'Hi-Toe 4', 'Hi-Toe 3', 'Hi-Toe 2', 'Hi-Toe Raw', 'Big Foot Hi-Toe',
          'MG4', 'MG4 TW', 'MG3', 'MG2', 'MG', 'Milled Grind', 'Milled Grind Hi-Toe', 'ATV', 'Z TP', 'xFT'
        ],
        putter: [
          'Spider Tour', 'Spider Tour X', 'Spider Tour Black', 'Spider GT', 'Spider GTX', 'Spider EX', 'Spider Mini',
          'Spider X', 'Spider S', 'Spider Interactive', 'Ghost Spider', 'Ghost Corza', 'Ghost Manta',
          'TP Reserve', 'TP Reserve TR B13', 'TP Reserve B11', 'TP Hydro Blast', 'TP Juno', 'TP Soto', 'TP Chaska', 'TP Mullen',
          'TP Patina', 'TP Black Copper', 'TP Ardmore', 'Rossa Daytona', 'Rossa Monza', 'Itsy Bitsy Spider',
          'Spider ZT', 'Spider Tour V', 'Spider Tour X L-Neck', 'Spider FCG', 'TP Collection Del Monte', 'TP Collection Osaka'
        ],
        iron_set: [
          'P790 2023', 'P790 2021', 'P790 2019', 'P790 2017',
          'P770 2023', 'P770 2020',
          'P7MC 2023', 'P7MC 2020',
          'P7MB 2023', 'P7MB 2020',
          'SIM Max OS', 'SIM2 Max OS', 'SIM Max', 'SIM2 Max', 'SIM',
          'Stealth HD', 'Qi Iron', 'Qi HL', 'PSi', 'RSi 1', 'RSi 2', 'SpeedBlade', 'RocketBladez',
          'Tour Preferred', 'MCGB', 'M1', 'M2', 'M3', 'M4', 'M5', 'M6', 'R9', 'Burner 2.0', 'r7', 'Kalea Gold'
        ],
        wedge_set: [
          'Hi-Toe 4', 'Hi-Toe 3', 'Hi-Toe 2', 'MG4', 'MG3', 'MG2', 'MG', 'Milled Grind', 'ATV', 'xFT'
        ]
      },
      Callaway: {
        driver: [
          'Elyte', 'Elyte X', 'Elyte Max', 'Elyte Max Fast', 'Elyte Triple Diamond', 'Elyte X Triple Diamond',
          'Paradym Ai Smoke Max', 'Paradym Ai Smoke Triple Diamond', 'Paradym Ai Smoke TD', 'Paradym Ai Smoke',
          'Paradym Ai Smoke Max D', 'Paradym Triple Diamond', 'Paradym X', 'Paradym',
          'Rogue ST Max', 'Rogue ST LS', 'Rogue ST Triple Diamond', 'Rogue ST Max D',
          'Mavrik', 'Mavrik Max', 'Mavrik Sub Zero', 'Mavrik Max W', 'Mavrik 22',
          'Epic Speed', 'Epic Max', 'Epic Max LS', 'Epic Flash', 'Epic Flash Sub Zero', 'Epic', 'Epic Sub Zero',
          'Big Bertha B21', 'Big Bertha Reva', 'Big Bertha Alpha 815', 'Big Bertha V Series', 'Big Bertha Alpha', 'Big Bertha',
          'XR 16', 'XR Pro 16', 'XR', 'X2 Hot', 'X2 Hot Pro', 'X Hot', 'X Hot Pro',
          'RAZR Fit Xtreme', 'RAZR Fit', 'FT Optiforce', 'FT5', 'Diablo Octane', 'FT-iZ'
        ],
        fairway: [
          'Elyte', 'Elyte X', 'Elyte Triple Diamond', 'Elyte Heavenwood',
          'Paradym Ai Smoke', 'Paradym Triple Diamond', 'Paradym',
          'Rogue ST', 'Rogue ST LS', 'Mavrik', 'Mavrik Max', 'Mavrik Sub Zero',
          'Epic Speed', 'Epic Max', 'Epic Flash', 'Epic',
          'XR 16', 'XR', 'X2 Hot', 'X Hot', 'Big Bertha', 'Big Bertha Alpha', 'Heavenwood', 'RAZR Fit'
        ],
        hybrid: [
          'Elyte', 'Elyte X', 'Paradym Ai Smoke', 'Paradym', 'Apex UW', 'Apex',
          'Rogue ST', 'Rogue', 'Mavrik', 'Epic Super Hybrid', 'Epic Flash', 'Epic',
          'X2 Hot', 'X Hot', 'Apex 19', 'Big Bertha', 'Heavenwood', 'RAZR X', 'Diablo Edge'
        ],
        iron: [
          'Apex', 'Apex Pro', 'Apex CB', 'Apex DCB', 'Apex UW', 'Apex MB', 'Apex CF16', 'Apex Ai200', 'Apex Ai300',
          'Paradym Ai Smoke', 'Paradym', 'Rogue ST Max OS', 'Rogue ST Pro', 'Rogue', 'Mavrik Pro',
          'Epic Forged', 'Epic Pro', 'XR', 'XR Pro', 'X2 Hot', 'X Hot', 'Steelhead XR',
          'Big Bertha OS', 'Big Bertha', 'Apex 19', 'Apex 21', 'Razor X', 'RAZR X HL', 'Diablo Edge', 'X-22', 'X-24',
          'Chrome Tour', 'Chrome Tour X'
        ],
        wedge: [
          'Jaws Raw', 'Opus', 'Opus Platinum', 'MD5', 'MD4', 'MD3', 'MD2', 'JAWS Full Toe', 'PM Grind', 'Sure Out', 'X-Forged',
          'Jaws Raw Black', 'Jaws Full Toe Raw', 'PM Grind 19', 'PM Grind 2.0'
        ],
        putter: [
          'Odyssey Ai-One', 'Odyssey Ai-One Square 2', 'Odyssey Ai-One Rossie', 'White Hot Versa', 'White Hot OG',
          'Tri-Hot 5K', 'Stroke Lab', 'Stroke Lab Black', 'Stroke Lab R-Line', 'EXO', 'O-Works', 'Works Tank',
          'Versa', 'Metal-X', 'White Ice', 'Marxman', '2-Ball Ten', '2-Ball'
        ],
        iron_set: [
          'Apex', 'Apex Pro', 'Apex CB', 'Apex DCB', 'Paradym Ai Smoke', 'Paradym', 'Rogue ST', 'Rogue', 'Mavrik',
          'Epic', 'XR', 'X Hot', 'Steelhead XR', 'Big Bertha', 'Apex 19', 'Apex 21', 'RAZR X', 'Diablo Edge'
        ],
        wedge_set: [
          'Jaws Raw', 'Opus', 'MD5', 'MD4', 'MD3', 'MD2', 'JAWS Full Toe', 'PM Grind', 'X-Forged'
        ]
      },
      Titleist: {
        driver: [
          'GT1', 'GT2', 'GT3', 'GT4', 'TSR2', 'TSR3', 'TSR4', 'TSi2', 'TSi3', 'TSi4', 'TS1', 'TS2', 'TS3', 'TS4',
          '917 D2', '917 D3', '915 D2', '915 D3', '913 D2', '913 D3', '910 D2', '910 D3', '909 D2', '909 D3',
          '816 D2', '816 D3', '816 D4', 'D2', 'D3', '905R', '905T'
        ],
        fairway: [
          'GT', 'GT2', 'GT3', 'TSR2', 'TSR3', 'TSi2', 'TSi3', 'TS2', 'TS3',
          '917 F2', '917 F3', '915 F', '913 F', '910 F', '909 F', '816 F2', '816 F3'
        ],
        hybrid: [
          'TSR3', 'TSR2', 'U·505', 'U·510', 'TS3', 'TS2', '816 H1', '816 H2', '915 Hd', '913 Hd', '910 H', '585 H'
        ],
        iron: [
          'T100', 'T150', 'T200', 'T300', 'T350', 'T400', '620 CB', '620 MB', '620 MB Raw',
          'AP3', 'AP2', 'AP1', '718 AP3', '718 AP2', '718 AP1', '716 AP2', '716 AP1', '714 AP2', '714 AP1',
          '712 AP2', '712 AP1', '710 AP2', '710 AP1', 'CB 716', 'MB 716', 'CB 714', 'MB 714', 'CB 712', 'MB 712',
          'CB 710', 'MB 710', 'CB 709', 'MB 709'
        ],
        wedge: [
          'Vokey SM10', 'Vokey SM9', 'Vokey SM8', 'Vokey SM7', 'Vokey SM6', 'Vokey SM5', 'Vokey TVD', 'WedgeWorks', 'Spin Milled'
        ],
        putter: [
          'Scotty Cameron Newport', 'Scotty Cameron Newport 2', 'Scotty Cameron Newport 2.5', 'Scotty Cameron Phantom',
          'Scotty Cameron Phantom X', 'Scotty Cameron Super Select', 'Scotty Cameron Special Select', 'Scotty Cameron Futura',
          'Scotty Cameron GoLo', 'Scotty Cameron Fastback', 'Scotty Cameron Squareback', 'Scotty Cameron Del Mar', 'Scotty Cameron California'
        ],
        iron_set: [
          'T100 2021', 'T100 2019', 'T100', 'T150', 'T200', 'T350', 'T400',
          '620', 'AP3', 'AP2', 'AP1', '718 AP2', '716 AP2', '714 AP2', '712 AP2', '710 AP2', 'CB/MB'
        ],
        wedge_set: [
          'Vokey SM10', 'Vokey SM9', 'Vokey SM8', 'Vokey SM7', 'Vokey SM6', 'Vokey SM5', 'Spin Milled'
        ]
      },
      Ping: {
        driver: [
          'G440 Max', 'G440 LST', 'G440 SFT', 'G440 K', 'G440 HL',
          'G430 Max', 'G430 Max 10K', 'G430 LST', 'G430 SFT', 'G430 HL',
          'G425 Max', 'G425 LST', 'G425 SFT', 'G425 Max HL',
          'G410 Plus', 'G410 LST', 'G410 SFT',
          'G400 Max', 'G400 LST', 'G400 SFT',
          'G400', 'G35', 'G30', 'G25', 'G20', 'G15', 'G10', 'Rapture', 'i20', 'Anser',
          'G Le3', 'G Le2', 'G Le'
        ],
        fairway: [
          'G440 Max', 'G440 LST', 'G440 SFT', 'G440 HL',
          'G430 Max', 'G430 LST', 'G430 SFT', 'G430 HL',
          'G425 Max', 'G425 LST', 'G425 SFT',
          'G410', 'G410 LST', 'G410 SFT',
          'G400', 'G400 LST', 'G400 SFT',
          'G35', 'G30', 'G25', 'G20', 'G15', 'Rapture', 'i20', 'G Le3', 'G Le2'
        ],
        hybrid: [
          'G440', 'G440 HL',
          'G430', 'G430 HL',
          'G425', 'G410', 'G400',
          'G35', 'G30', 'G25', 'G20', 'G15',
          'Rapture', 'iCrossover', 'Prodi G', 'Anser', 'G Le3', 'G Le2'
        ],
        iron: [
          'i530', 'i525', 'i500', 'i230', 'i210', 'i200', 'iBlade',
          'Blueprint', 'Blueprint S', 'Blueprint T',
          'G440', 'G430', 'G425', 'G410', 'G400', 'G35', 'G30', 'G25', 'G20',
          'i20', 'i15', 'S55', 'S56', 'S59', 'Eye 2', 'Rapture V2',
          'G Le3', 'G Le2'
        ],
        wedge: [
          'Glide 4.0', 'Glide 3.0', 'Glide 2.0', 'Glide Forged', 'Glide Forged Pro',
          's159', 's158', 'Blueprint', 'Eye 2 XG', 'SS', 'ES'
        ],
        putter: [
          'PLD Milled Anser', 'PLD Milled Anser 2', 'PLD Milled Anser 2D', 'PLD Milled Anser 4D',
          'PLD Milled Blade', 'PLD Milled Prime', 'PLD Milled Craz-E',
          'PLD Milled M365', 'PLD Milled DS72', 'PLD Milled Ally',
          'PLD Milled Oslo', 'PLD Milled Oslo 3', 'PLD Milled Oslo 4',
          'PLD Anser', 'PLD Anser 2', 'PLD Anser 4', 'PLD Craz-E', 'PLD Prime Tyne', 'PLD Prime Milled',
          'Anser', 'Anser 2', 'Anser 4', 'DS72', 'DS79', 'Tomcat 14', 'Fetch',
          'Tyne', 'Tyne 4', 'Harwood', 'Piper', 'Kushin', 'Heppler Anser 2',
          'Vault 2.0', 'Vault 2.0 Dale', 'Vault 2.0 Kory', 'Vault 2.0 ZB', 'Sigma 2', 'Sigma G'
        ],
        iron_set: [
          'i530', 'i525', 'i500', 'i230', 'i210', 'i200', 'iBlade',
          'Blueprint', 'Blueprint S', 'Blueprint T',
          'G440', 'G430', 'G425', 'G410', 'G400', 'G35', 'G30', 'G25', 'G20', 'i20',
          'G Le3', 'G Le2'
        ],
        wedge_set: [
          'Glide 4.0', 'Glide 3.0', 'Glide 2.0', 'Glide Forged', 'Glide Forged Pro', 's159', 'Blueprint', 'Eye 2'
        ]
      },
      Cobra: {
        driver: [
          'DS-ADAPT MAX-K', 'DS-ADAPT MAX-D', 'DS-ADAPT MAX-X', 'DS-ADAPT MAX-A', 'DS-ADAPT LS', 'DS-ADAPT MAX',
          'Darkspeed', 'Darkspeed LS', 'Darkspeed X', 'Darkspeed Max', 'Aerojet', 'Aerojet LS', 'Aerojet Max',
          'LTDx', 'LTDx LS', 'LTDx Max', 'Radspeed', 'Radspeed XB', 'Speedzone', 'Speedzone Xtreme',
          'F9', 'F8', 'F7', 'F6', 'Fly-Z', 'Fly-Z+', 'Amp Cell', 'Bio Cell', 'King LTD', 'Long Tom'
        ],
        fairway: [
          'DS-ADAPT', 'DS-ADAPT MAX', 'DS-ADAPT X',
          'Darkspeed', 'Aerojet', 'LTDx', 'Radspeed', 'Speedzone', 'F9', 'F8', 'F7', 'Fly-Z', 'Bio Cell', 'King Tec', 'Baffler XL'
        ],
        hybrid: [
          'DS-ADAPT', 'DS-ADAPT MAX', 'Darkspeed', 'Aerojet', 'LTDx', 'Radspeed', 'Speedzone',
          'F9', 'F8', 'King Tec', 'Baffler', 'Bio Cell', 'Amp Offset'
        ],
        iron: [
          'King Tec', 'King Forged Tec', 'King Tour', 'King CB', 'King MB', 'King Utility',
          'Aerojet', 'LTDx', 'Radspeed', 'Speedzone', 'F9', 'F8', 'F7', 'Fly-Z', 'Bio Cell',
          'Amp Cell', 'Trusty Rusty', 'S3 Pro', 'S2', 'S9-1', 'LIMIT3D'
        ],
        wedge: [
          'Snakebite', 'Snakebite Wide', 'King MIM', 'King Black', 'Trusty Rusty', 'Pur', 'Cell', 'King CB'
        ],
        putter: [
          '3D Printed', '3D Printed Agera', '3D Printed SuperNova', 'King GrandSport', 'King Vintage', 'King F7', 'Cell', 'Trusty Rusty', 'LIMIT3D'
        ],
        iron_set: [
          'King Tec', 'King Forged Tec', 'King Forged Tec 2020', 'King Tour', 'Darkspeed',
          'F9 Speedback', 'Aerojet', 'LTDx', 'Radspeed', 'Speedzone', 'F9', 'F8', 'King F7', 'F7', 'Fly-Z', 'Bio Cell', 'Amp',
          '3D Printed', 'LIMIT3D'
        ],
        wedge_set: [
          'Snakebite', 'King MIM', 'King Black', 'Trusty Rusty', 'Pur'
        ]
      },
      Mizuno: {
        driver: [
          'ST-Max 245', 'ST-Max 230', 'ST-Z 230', 'ST-X 230', 'ST-Z 220', 'ST-X 220', 'ST-Z 200', 'ST-X 200',
          'ST190', 'ST200', 'GT180', 'GT190', 'JPX900', 'JPX850', 'JPX800', 'MP-650', 'MP-600', 'ST-180'
        ],
        fairway: [
          'ST-Max 245', 'ST-Z', 'ST-X', 'ST200', 'CLK', 'CLK Hybrid', 'ST190', 'JPX900', 'JPX850', 'MP-650', 'MP Fli-Hi'
        ],
        hybrid: [
          'ST-Max 245', 'CLK', 'Fli-Hi', 'JPX Fli-Hi', 'MP Fli-Hi', 'ST-Z', 'ST200', 'JPX900', 'JPX850'
        ],
        iron: [
          'Pro 241', 'Pro 243', 'Pro 225', 'Pro 245',
          'JPX 925 Tour', 'JPX 925 Forged', 'JPX 925 Hot Metal', 'JPX 925 Hot Metal HL',
          'JPX 923 Tour', 'JPX 923 Forged', 'JPX 923 Hot Metal', 'JPX 923 Hot Metal HL',
          'JPX 921 Tour', 'JPX 921 Forged', 'JPX 921 Hot Metal', 'JPX 919 Tour', 'JPX 919 Forged', 'JPX 919 Hot Metal',
          'JPX 900', 'JPX 850', 'JPX 800', 'MP-20', 'MP-18', 'MP-25', 'MP-54', 'MP-53', 'MP-59', 'MP-64', 'MP-68', 'MP-69'
        ],
        wedge: [
          'T24', 'T22', 'T20', 'ES21', 'ES', 'S18', 'S5', 'MP-T5', 'MP-R12', 'MP-T7'
        ],
        putter: [
          'M.Craft', 'M.Craft OMOI', 'M.Craft IV', 'M.Craft III', 'M.Craft II', 'Bettinardi Mizuno', 'TP Mills', 'M.Craft V'
        ],
        iron_set: [
          'Pro 241', 'Pro 245', 'Pro 223', 'JPX 925', 'JPX 923', 'JPX 921', 'JPX 919', 'JPX 900', 'JPX 850', 'JPX 800',
          'MP-20 MMC', 'MP-20', 'MP-18', 'MP-25', 'MP-54', 'MP-53'
        ],
        wedge_set: [
          'T24', 'T22', 'T20', 'ES21', 'ES', 'S18', 'S5', 'MP-T5'
        ]
      },
      Srixon: {
        driver: [
          'ZXi', 'ZXi Max', 'ZXi LS', 'ZX5 Mk III', 'ZX7 Mk III', 'ZX5 Mk II LS', 'ZX5 Mk II', 'ZX7 Mk II',
          'ZX5', 'ZX7', 'Z 785', 'Z 585', 'Z 565', 'Z 745', 'Z 545', 'Z 355', 'Z 155', 'Z 725', 'Z 525'
        ],
        fairway: [
          'ZXi', 'ZX Mk III', 'ZX Mk II', 'ZX5', 'ZX7', 'Z F85', 'Z H85', 'Z 355', 'Z 565', 'Z 745', 'Z 525'
        ],
        hybrid: [
          'ZXi', 'ZX Mk III', 'ZX Mk II', 'Z H85', 'Z U85', 'Z 355', 'Z 565', 'Adams Idea', 'Z 545'
        ],
        iron: [
          'ZXi', 'ZXi Mk II', 'ZX7 Mk III', 'ZX5 Mk III', 'ZX4 Mk III',
          'ZX7 Mk II', 'ZX5 Mk II', 'ZX4 Mk II', 'ZX7', 'ZX5', 'ZX4',
          'Z 785', 'Z 585', 'Z 565', 'Z 355', 'Z 545', 'Z 745', 'Z 925', 'Z 745 Tour', 'Z 545 Tour'
        ],
        wedge: [
          'ZX Mk III', 'ZX Mk II', 'Z Forged', 'Z 585 wedge', 'Z 785 wedge', 'RTG'
        ],
        putter: [
          'ZX', 'Z Series', 'Cleveland Frontline'
        ],
        iron_set: [
          'ZXi', 'ZX7 Mk III', 'ZX5 Mk III', 'ZX5 2021', 'ZX4 Mk III',
          'ZX7 Mk II', 'ZX5 Mk II', 'ZX4 Mk II', 'ZX7', 'ZX5', 'ZX4',
          'Z 785', 'Z 585', 'Z 565', 'Z 355', 'Z 925'
        ],
        wedge_set: [
          'ZX Mk III', 'ZX', 'Z Forged'
        ]
      },
      Cleveland: {
        driver: [
          'Launcher XL2', 'Launcher XL2 Lite', 'Launcher XL', 'Launcher XL Lite',
          'Launcher HB', 'Launcher HB Turbo', 'Launcher Turbo', 'HB Soft', 'Classic XL',
          '588 Altitude', '588 Custom', 'CG Black', 'HiBore XL', 'HiBore Monster', 'Launcher Comp', 'Launcher DST', 'Launcher 460'
        ],
        fairway: [
          'Launcher XL2', 'Launcher XL', 'Launcher Halo', 'Launcher HB', 'Launcher FL',
          '588', 'CG Black', 'HiBore', 'Launcher Comp', 'Classic XL'
        ],
        hybrid: [
          'Launcher XL2 Halo', 'Launcher XL Halo', 'Launcher Halo', 'Launcher FL', '588', 'HiBore', 'Niblick', 'Baffler'
        ],
        iron: [
          'Launcher XL2', 'Launcher XL', 'Launcher HB', 'Launcher UHX', 'Launcher CBX', 'Launcher CBX Lite',
          '588 MT', '588 TT', 'CG7', 'CG16', 'TA7', 'VAS 792', '588 Forged'
        ],
        wedge: [
          'RTX 6 ZipCore XL', 'RTX ZipCore', 'RTX Full-Face', 'RTX 6', 'RTX 4', 'RTX 3',
          '588 RTX', '588', 'CG15', 'Niblick', 'Smart Sole', 'CBX ZipCore', 'CBX Full-Face'
        ],
        putter: [
          'Huntington Beach', 'Huntington Beach Soft', 'Huntington Beach Soft #1', 'Huntington Beach Soft #4', 'Huntington Beach Soft #6',
          'Frontline', 'Frontline Elite', 'TFi 2135', 'Classic Collection', 'VP', 'Elevado'
        ],
        iron_set: [
          'Launcher XL2', 'Launcher XL', 'Launcher HB', 'Launcher UHX', 'Launcher CBX', '588', 'CG7', 'CG16', 'TA7'
        ],
        wedge_set: [
          'RTX ZipCore', 'RTX Full-Face', 'RTX 6', 'RTX 4', 'RTX 3', '588 RTX', 'Smart Sole', 'CBX ZipCore'
        ]
      },
      Wilson: {
        driver: [
          'Dynapower Max', 'Dynapower Max LS', 'Dynapower', 'Dynapower Carbon', 'Staff Model', 'Staff Model D',
          'D9', 'D7', 'D300', 'C300', 'FG Tour', 'FG Tour F5', 'FG Tour V6', 'Deep Red', 'Smooth', 'Ci11', 'D200'
        ],
        fairway: [
          'Dynapower Max', 'Dynapower', 'Staff Model', 'D9', 'D7', 'D300', 'FG Tour', 'FG Tour F5', 'Deep Red', 'C300'
        ],
        hybrid: [
          'Dynapower Max', 'Dynapower', 'D9', 'D7', 'D300', 'FG Tour', 'Fybrid', 'FYbrid RS', 'Staff Model'
        ],
        iron: [
          'Staff Model', 'Staff Model Blade', 'Staff Model CB', 'Staff Model CB2', 'Staff Model D',
          'Dynapower', 'Dynapower Max', 'Launch Pad', 'D9', 'D7', 'D300', 'C300',
          'FG Tour V6', 'FG Tour F5', 'FG Tour 100', 'Ci11', 'Ci9', 'Pi5', 'Pi7', 'Model D'
        ],
        wedge: [
          'Staff Model', 'Staff Model V', 'Harmonized', 'PMP', 'TW9', 'Harmonized Tour Grind'
        ],
        putter: [
          'Infinite', 'Infinite Blade', 'Infinite Milled', 'Staff Model', '888', '8882', 'South Side', 'North Side', 'Infinite Buckingham'
        ],
        iron_set: [
          'Staff Model', 'Dynapower', 'Dynapower Max', 'Launch Pad', 'D9', 'D7', 'D300', 'FG Tour', 'Ci11', 'Ci9'
        ],
        wedge_set: [
          'Staff Model', 'Harmonized', 'PMP', 'TW9'
        ]
      },
      PXG: {
        driver: [
          '0311 Black Ops', '0311 GEN7', '0311 GEN7 LS', '0311 GEN7 X', '0311 GEN7 XT', '0311 GEN7 XF',
          '0311 GEN6', '0311 XF GEN6', '0311 XT GEN6', '0311 XF GEN5', '0311 XT GEN5',
          '0311 GEN4', '0311 XF GEN4', '0311 XT GEN4', '0811 X', '0811 XF', '0811 LX', '0811 XT', '0811 X GEN2', '0811 XF Gen2'
        ],
        fairway: [
          '0311 Black Ops', '0311 GEN7', '0311 GEN7 XF', '0311 GEN7 XT', '0311 XF', '0311 XT',
          '0341 X', '0341 XF', '0341', '0817 X', '0817 XF', '0311 GEN6'
        ],
        hybrid: [
          '0311 Black Ops', '0311 GEN7', '0311 X GEN4', '0317', '0317 X', '0317 X Gen2', '0317 X Gen3', '0317 X Gen4', '0317 X Gen5'
        ],
        iron: [
          '0311 Black Ops', '0311 P GEN7', '0311 T GEN7', '0311 ST GEN7', '0311 XP GEN7', '0311 XP',
          '0311 P GEN6', '0311 T GEN6', '0311 ST GEN6', '0311 P GEN5', '0311 T GEN5',
          '0311 P GEN4', '0311 T GEN4', '0311 P GEN3', '0311 T GEN3', '0311 P GEN2', '0311 T GEN2', '0311', '0211', '0211 Z'
        ],
        wedge: [
          '0311 Sugar Daddy', '0311 Forged', '0311', 'Sugar Daddy II', '0311 3X', '0311 Sugar Daddy II'
        ],
        putter: [
          'Battle Ready', 'Battle Ready II', 'Blackjack', 'Closers', 'Gunboat', 'Operator', 'Spitfire', 'Mustang', 'Bat Attack', 'Dagger', 'Lucky D', 'One & Done'
        ],
        iron_set: [
          '0311 Black Ops', '0311 P GEN7', '0311 T GEN7', '0311 ST GEN7', '0311 XP', '0311 P GEN6', '0311 T GEN6',
          '0311 P GEN5', '0311 T GEN5', '0311 P GEN4', '0311 T GEN4', '0311 P GEN3', '0311 T GEN3', '0211'
        ],
        wedge_set: [
          '0311 Sugar Daddy', '0311 Forged', 'Sugar Daddy II', '0311 3X'
        ]
      },
      Odyssey: {
        putter: [
          'Ai-ONE', 'Ai-ONE Cruiser', 'Ai-ONE Milled', 'Ai-ONE Rossie', 'Ai-ONE Jailbird', 'Ai-ONE Double Wide', 'Ai-ONE #1', 'Ai-ONE #7',
          'Tri-Hot 5K', 'Tri-Hot 5K Double Wide', 'Tri-Hot 5K Rossie', 'Tri-Hot 5K #1', 'Tri-Hot 5K #7',
          'White Hot OG #1', 'White Hot OG #7', 'White Hot OG Rossie', 'White Hot OG 2-Ball', 'White Hot OG #5', 'White Hot OG #3',
          'White Hot RX #1', 'White Hot RX #2', 'White Hot RX #7', 'White Hot RX V-Line', 'White Hot RX 2-Ball',
          'O-Works #1', 'O-Works #2', 'O-Works #7', 'O-Works Tank', 'O-Works 2-Ball Fang', 'O-Works V-Line Fang', 'O-Works Red', 'O-Works Black',
          'Stroke Lab', 'Stroke Lab Ten', 'Stroke Lab Eleven', 'Stroke Lab Seven', 'Stroke Lab Three', 'Stroke Lab Voyager',
          'Stroke Lab Black', 'Stroke Lab 2-Ball Ten', 'Stroke Lab Bird of Prey', 'Stroke Lab V-Line',
          'Versa #12', 'Versa #18', 'Versa Twelve', 'Versa Eight', 'Versa #1', 'Versa #7',
          'Toulon Design Austin', 'Toulon Design Madison', 'Toulon Design San Francisco', 'Toulon Design Chicago',
          'Toulon Design Atlanta', 'Toulon Design Rochester', 'Toulon Design Las Vegas', 'Toulon Design Miami', 'Toulon Design Portland',
          'Milled Collection RSX', 'Milled Collection #1', 'Milled Collection #7', 'Milled Collection #2', 'Milled Collection RSX #1',
          'Works #7X', 'Works #1X', 'Works #9X', 'Works Versa #7', 'Works Tank Cruiser',
          'DFX #7', 'DFX #1', 'DFX 2-Ball', 'DFX Rossie', 'DFX #5',
          'Rossie S', 'Two-Ball Ten', 'Eleven Triple Track', 'Ten S', 'Seven S', '2-Ball', 'White Hot Pro #1', 'White Hot Pro #2'
        ],
        wedge: [
          'White Hot', 'Stroke Lab Wedge', 'X-Act Tank Chipper'
        ],
        wedge_set: [
          'White Hot', 'Stroke Lab Wedge'
        ]
      },
      'Scotty Cameron': {
        putter: [
          'Super Select Newport', 'Super Select Newport 2', 'Super Select Newport 2.5', 'Super Select Newport 2.5 Plus',
          'Super Select Fastback', 'Super Select Squareback', 'Super Select Del Mar', 'Super Select Kombi', 'Super Select Newport M1 Mallet', 'Super Select Newport M2 Mallet',
          'Special Select Newport', 'Special Select Newport 2', 'Special Select Newport 2.5', 'Special Select Fastback 1.5',
          'Special Select Squareback 2', 'Special Select Del Mar', 'Special Select Flowback 5', 'Special Select Flowback 5.5',
          'Phantom 5', 'Phantom 7', 'Phantom 9', 'Phantom 11', 'Phantom 11.5', 'Phantom 5.2', 'Phantom 7.2', 'Phantom 7.5',
          'Phantom X 5', 'Phantom X 5.5', 'Phantom X 7', 'Phantom X 7.5', 'Phantom X 8', 'Phantom X 8.5',
          'Phantom X 9', 'Phantom X 11', 'Phantom X 12', 'Phantom X 12.5', 'Phantom X 5s', 'Phantom X 6', 'Phantom X 6.5',
          'Newport', 'Newport 2', 'Newport 2.5', 'Newport 2.5 Plus', 'Newport M1 Mallet', 'Newport M2 Mallet', 'Newport 2 GSS',
          'Futura 5MB', 'Futura 7M', 'Futura X5R', 'Futura X7M', 'Futura 6M', 'Futura 8M', 'Futura 5W', 'Futura 7W',
          'GoLo 3', 'GoLo 3R', 'GoLo 5R', 'GoLo 6', 'GoLo 7', 'GoLo 5',
          'Fastback', 'Squareback', 'Del Mar', 'California', 'Cameron & Crown 6M', 'Cameron & Crown 5.5M',
          'Select Newport 2', 'Select GoLo', 'Select Fastback', 'Select Squareback', 'Select Newport', 'Select Newport 2.5',
          'Studio Select Newport 2', 'Studio Select Kombi', 'Studio Style Newport 2', 'Studio Select Fastback 1', 'Studio Select Squareback 2',
          'Circa 62 #1', 'Circa 62 #2', 'Circa 62 #3', 'Red X', 'Detour', 'Detour 2.0', 'M1', 'M2', 'M3', 'M5', 'M10'
        ]
      }
    };

    function getBrandDisplay() {
      if (!brandSelect || !brandSelect.value) return '';
      if (brandSelect.value === '__other__') return (brandCustom && brandCustom.value) ? brandCustom.value.trim() : '';
      var opt = brandSelect.options[brandSelect.selectedIndex];
      return opt ? opt.text : '';
    }

    function getModelDisplay() {
      if (!brandSelect) return '';
      if (brandSelect.value === '__other__')
        return modelCustom ? modelCustom.value.trim() : '';
      if (!modelSelect) return '';
      if (modelSelect.value === '__custom__')
        return modelCustom ? modelCustom.value.trim() : '';
      if (modelSelect.value) {
        var o = modelSelect.options[modelSelect.selectedIndex];
        return o ? o.text : '';
      }
      return '';
    }

    function getLoftDisplay() {
      if (!loftSelect) return '';
      if (loftSelect.value === '__other__')
        return loftCustom ? loftCustom.value.trim() : '';
      return loftSelect.value ? loftSelect.value : '';
    }

    function getClubTypeText() {
      syncTypeFromPicker();
      return typeEl && typeEl.selectedOptions[0] ? typeEl.selectedOptions[0].text : '';
    }

    function getClubShortLabel() {
      var parts = [getBrandDisplay(), getModelDisplay()].filter(Boolean);
      if (!parts.length) {
        var typeText = getClubTypeText();
        if (typeText) parts.push(typeText);
      }
      return parts.join(' ') || 'Klubba';
    }

    function isPutterType() {
      return getClubTypeValue() === 'putter';
    }

    function isWedgeType() {
      var t = getClubTypeValue();
      return t === 'wedge' || t === 'wedge_set';
    }

    function showsHeadcoverQuestion() {
      var t = getClubTypeValue();
      return t !== 'iron' && t !== 'iron_set' && t !== 'wedge' && t !== 'wedge_set';
    }

    function syncFlexOptionsUi() {
      if (!flexEl) return;
      var showWedgeFlex = isWedgeType();
      var wedgeOpt = flexEl._wedgeFlexOption || flexEl.querySelector('option[data-gcv-flex-wedge]');
      if (!wedgeOpt) return;
      flexEl._wedgeFlexOption = wedgeOpt;

      if (!showWedgeFlex && flexEl.value === 'wedge') {
        flexEl.value = '';
      }

      if (showWedgeFlex) {
        if (!wedgeOpt.parentNode) {
          var regularOpt = flexEl.querySelector('option[value="regular"]');
          if (regularOpt && regularOpt.nextSibling) {
            flexEl.insertBefore(wedgeOpt, regularOpt.nextSibling);
          } else {
            flexEl.appendChild(wedgeOpt);
          }
        }
        wedgeOpt.disabled = false;
      } else if (wedgeOpt.parentNode) {
        wedgeOpt.parentNode.removeChild(wedgeOpt);
      }
    }

    function syncPutterSpecsUi() {
      var isPutter = isPutterType();
      var showHeadcover = showsHeadcoverQuestion();
      if (shaftFieldWrap) shaftFieldWrap.hidden = isPutter;
      if (flexFieldWrap) flexFieldWrap.hidden = isPutter;
      if (loftFieldWrap) loftFieldWrap.hidden = isPutter;
      if (headcoverFieldWrap) headcoverFieldWrap.hidden = !showHeadcover;
      if (loftCustomWrap) {
        if (isPutter) {
          loftCustomWrap.hidden = true;
          if (loftCustom) loftCustom.value = '';
        } else {
          syncLoftCustomUi();
        }
      }
      if (isPutter) {
        if (shaftEl) shaftEl.value = '';
        if (flexEl) flexEl.value = '';
        if (loftSelect) loftSelect.value = '';
        markFieldError(shaftEl, false);
        markFieldError(flexEl, false);
        markFieldError(loftSelect, false);
        markFieldError(loftCustom, false);
      } else {
        markFieldError(shaftEl, false);
        markFieldError(flexEl, false);
      }
      if (!showHeadcover) {
        if (headcoverEl) headcoverEl.value = '';
        markFieldError(headcoverEl, false);
      }
      syncFlexOptionsUi();
    }

    function readSelectDisplay(el) {
      if (!el || !el.value) return '—';
      return el.selectedOptions[0] ? el.selectedOptions[0].text : '—';
    }

    function buildClubDetailLines() {
      var clubType = typeEl ? typeEl.value : '';
      var isPutter = clubType === 'putter';
      var lines = [
        'Klubbtyp: ' + getClubTypeText(),
        'Märke: ' + getBrandDisplay(),
        'Modell: ' + getModelDisplay(),
        'Fattning: ' + readSelectDisplay(handednessEl)
      ];
      if (!isPutter) {
        lines.push('Skaft: ' + readSelectDisplay(shaftEl));
        lines.push('Flex: ' + readSelectDisplay(flexEl));
        lines.push(
          clubType === 'iron_set' || clubType === 'wedge_set'
            ? 'Uppsättning: ' + (getLoftDisplay() || '—')
            : 'Loft/järn: ' + getLoftDisplay()
        );
      }
      lines.push('Skick: ' + readSelectDisplay(conditionEl));
      if (showsHeadcoverQuestion()) {
        lines.push('Original headcover: ' + readSelectDisplay(headcoverEl));
      }
      return lines.filter(Boolean);
    }

    function clearPendingPhotos() {
      pendingPhotos.forEach(function (item) {
        if (item.previewUrl) URL.revokeObjectURL(item.previewUrl);
      });
      pendingPhotos = [];
      renderPhotoPreviews();
      showPhotosError('');
      markPhotosSectionError(false);
      if (photosInput) photosInput.value = '';
    }

    function resetClubFieldsForNewEntry() {
      if (typeEl) typeEl.value = '';
      syncTypePickerUi();
      loftBuiltForType = null;
      if (brandSelect) brandSelect.value = '';
      syncBrandOtherUi();
      resetModelSelect();
      if (shaftEl) shaftEl.value = '';
      if (flexEl) flexEl.value = '';
      rebuildLoftOptions();
      if (conditionEl) conditionEl.value = '';
      if (handednessEl) handednessEl.value = '';
      if (headcoverEl) headcoverEl.value = '';
      clearPendingPhotos();
      clearAllFieldErrors();
      syncPutterSpecsUi();
    }

    function handleAddAnotherClub() {
      if (window.GolfVardering && window.GolfVardering.invalidateEstimateIfStale) {
        window.GolfVardering.invalidateEstimateIfStale(form);
      }
      if (!form.dataset.gcvAiPrice) return;

      if (!hasRequiredPhotos()) {
        showPhotosError(photosRequiredMessage());
        markPhotosSectionError(true);
        if (photosInput) photosInput.focus();
        return;
      }

      var gross = Math.round(parseFloat(form.dataset.gcvAiPrice));
      if (!Number.isFinite(gross) || gross <= 0) return;

      savedClubs.push({
        label: getClubShortLabel(),
        grossPrice: gross,
        detailLines: buildClubDetailLines(),
        photos: pendingPhotos.map(function (item) {
          return { file: item.file, previewUrl: item.previewUrl, id: item.id };
        }),
        photoCount: pendingPhotos.length
      });

      checkoutFinalized = false;
      pendingPhotos = [];
      renderPhotoPreviews();
      if (photosInput) photosInput.value = '';

      if (window.GolfVardering && window.GolfVardering.resetEstimate) {
        window.GolfVardering.resetEstimate(form);
      }

      resetClubFieldsForNewEntry();
      renderClubsCart();
      updateProgressLabel(0);
      showStep(0, true);
    }

    function appendDegOptions(select, minHalf, maxHalf) {
      for (var i = minHalf; i <= maxHalf; i++) {
        var d = i / 2;
        var label = d + '°';
        var o = document.createElement('option');
        o.value = label;
        o.textContent = label;
        select.appendChild(o);
      }
    }

    function appendIntDegOptions(select, minD, maxD) {
      for (var d = minD; d <= maxD; d++) {
        var t = d + '°';
        var o = document.createElement('option');
        o.value = t;
        o.textContent = t;
        select.appendChild(o);
      }
    }

    function syncLoftCustomUi() {
      if (!loftSelect || !loftCustomWrap) return;
      var show = loftSelect.value === '__other__';
      loftCustomWrap.hidden = !show;
      if (!show && loftCustom) loftCustom.value = '';
    }

    function rebuildLoftOptions() {
      if (!loftSelect || !typeEl) return;
      var t = typeEl.value;
      if (loftBuiltForType === t && loftSelect.options.length > 1) return;
      loftBuiltForType = t;

      while (loftSelect.firstChild) loftSelect.removeChild(loftSelect.firstChild);

      var empty = document.createElement('option');
      empty.value = '';
      empty.textContent =
        t === 'iron_set' || t === 'wedge_set' ? 'Välj uppsättning … (valfritt)' : 'Välj … (valfritt)';
      loftSelect.appendChild(empty);

      function finish() {
        var oc = document.createElement('option');
        oc.value = '__other__';
        oc.textContent = 'Annat värde …';
        loftSelect.appendChild(oc);
        loftSelect.value = '';
        syncLoftCustomUi();
      }

      function setLabel(html) {
        if (loftLabelEl) loftLabelEl.innerHTML = html;
      }

      if (!t) {
        setLabel('Loft / järn (valfritt)');
        finish();
        return;
      }

      switch (t) {
        case 'driver':
          setLabel('Driver-loft (°) <span class="golf-valuation__loft-hint">7°–13°</span>');
          appendDegOptions(loftSelect, 14, 26);
          break;
        case 'fairway':
          setLabel('Fairway-loft (°) <span class="golf-valuation__loft-hint">ca 13°–24°</span>');
          appendDegOptions(loftSelect, 26, 48);
          break;
        case 'hybrid':
          setLabel('Hybrid-loft (°) <span class="golf-valuation__loft-hint">ca 16°–31°</span>');
          appendDegOptions(loftSelect, 32, 62);
          break;
        case 'iron': {
          setLabel('Järn <span class="golf-valuation__loft-hint">klubbnummer</span>');
          var irons = ['2 järn', '3 järn', '4 järn', '5 järn', '6 järn', '7 järn', '8 järn', '9 järn', 'PW', 'GW', 'AW', 'SW', 'LW'];
          irons.forEach(function (name) {
            var o = document.createElement('option');
            o.value = name;
            o.textContent = name;
            loftSelect.appendChild(o);
          });
          break;
        }
        case 'wedge':
          setLabel('Wedge-loft (°) <span class="golf-valuation__loft-hint">ca 46°–64°</span>');
          appendIntDegOptions(loftSelect, 46, 64);
          break;
        case 'putter':
          setLabel('Loft (valfritt)');
          break;
        case 'iron_set':
          setLabel('Uppsättning <span class="golf-valuation__loft-hint">t.ex. 5–PW (valfritt)</span>');
          [
            '3–PW',
            '4–PW',
            '5–PW',
            '6–PW',
            '4–9',
            '4–GW',
            '5–GW',
            '6–GW',
            '5–SW',
            'Vet ej / varierar'
          ].forEach(function (name) {
            var o = document.createElement('option');
            o.value = name;
            o.textContent = name;
            loftSelect.appendChild(o);
          });
          break;
        case 'wedge_set':
          setLabel('Uppsättning <span class="golf-valuation__loft-hint">typiska loft (valfritt)</span>');
          [
            '48° / 54° / 60°',
            '50° / 54° / 58°',
            '52° / 56° / 60°',
            '50° / 56°',
            '54° / 58° / 62°',
            'Blandade / vet ej'
          ].forEach(function (name) {
            var o = document.createElement('option');
            o.value = name;
            o.textContent = name;
            loftSelect.appendChild(o);
          });
          break;
        default:
          setLabel('Loft (valfritt)');
      }

      finish();
    }

    function buildBody(imageUrls) {
      var lines = [
        '=== Golfklubb-värdering ===',
        'Namn: ' + (nameEl ? nameEl.value : ''),
        'E-post: ' + (emailEl ? emailEl.value : ''),
        'Telefon: ' + (phoneEl ? phoneEl.value : '')
      ];
      var urlIndex = 0;
      var allUrls = imageUrls || [];

      function appendClubBlock(index, label, detailLines, grossPrice, photoCount) {
        lines.push('', '--- Klubba ' + index + ': ' + label + ' ---');
        detailLines.forEach(function (line) {
          lines.push(line);
        });
        if (grossPrice) {
          lines.push('Prisförslag: ' + formatSek(grossPrice));
        }
        if (photoCount > 0) {
          lines.push('Bifogade bilder:');
          for (var i = 0; i < photoCount; i++) {
            if (allUrls[urlIndex]) {
              lines.push('Bild ' + (i + 1) + ': ' + allUrls[urlIndex]);
              urlIndex++;
            }
          }
        }
      }

      savedClubs.forEach(function (club, i) {
        appendClubBlock(i + 1, club.label, club.detailLines, club.grossPrice, club.photoCount || 0);
      });

      if (form && form.dataset.gcvAiPrice) {
        appendClubBlock(
          savedClubs.length + 1,
          getClubShortLabel(),
          buildClubDetailLines(),
          Math.round(parseFloat(form.dataset.gcvAiPrice)),
          pendingPhotos.length
        );
      }

      var totalGross = getTotalGrossPrice();
      var netPrice = getNetOfferPrice(totalGross);
      if (totalGross) {
        lines.push('', '=== Summa ===');
        lines.push('Totalt prisförslag: ' + formatSek(totalGross));
        if (form.dataset.gcvShippingDeduction) {
          lines.push('Fraktavdrag: ' + formatSek(parseFloat(form.dataset.gcvShippingDeduction)));
        }
        lines.push('Utbetalning efter frakt: ' + formatSek(netPrice));
        if (form.dataset.gcvAiEstimate && form.dataset.gcvAiEstimate.indexOf(' — ') !== -1) {
          lines.push(
            'AI-motivering senaste klubba (internt): ' +
              form.dataset.gcvAiEstimate.split(' — ').slice(1).join(' — ')
          );
        }
      }

      var payout = getSelectedPayout();
      if (payout) {
        lines.push('Utbetalningsmetod: ' + payout.label);
        if (payout.value === 'swish' && payoutSwishPhone && payoutSwishPhone.value.trim()) {
          lines.push('Swish-nummer: ' + payoutSwishPhone.value.trim());
        }
        if (payout.value === 'bank_transfer') {
          if (payoutClearing && payoutClearing.value.trim()) {
            lines.push('Clearingnummer: ' + payoutClearing.value.trim());
          }
          if (payoutAccount && payoutAccount.value.trim()) {
            lines.push('Kontonummer: ' + payoutAccount.value.trim());
          }
        }
        if (payout.value === 'store_credit' && netPrice) {
          lines.push(
            'Butikskredit med bonus: ' + formatSek(Math.round(netPrice * (1 + STORE_CREDIT_BONUS)))
          );
        }
      }
      if (form && form.dataset.gcvShippingInfo) {
        lines.push('Frakt: ' + form.dataset.gcvShippingInfo);
        lines.push('Leverans: QR-kod hos ombud, skickas med DSV');
      }
      if (savedClubs.length > 0) {
        lines.push('Antal klubbor: ' + (savedClubs.length + (form.dataset.gcvAiPrice ? 1 : 0)));
      }
      return lines.filter(Boolean).join('\n');
    }

    function showPhotosError(msg) {
      if (!photosError) return;
      if (!msg) {
        photosError.hidden = true;
        photosError.textContent = '';
        return;
      }
      photosError.hidden = false;
      photosError.textContent = msg;
    }

    function hasRequiredPhotos() {
      return pendingPhotos.length >= minPhotos;
    }

    function photosRequiredMessage() {
      if (minPhotos <= 0) return '';
      if (minPhotos === 1) return 'Ladda upp minst en bild av klubban.';
      return 'Ladda upp minst ' + minPhotos + ' bilder av klubban.';
    }

    function compressImageFile(file) {
      return new Promise(function (resolve, reject) {
        var img = new Image();
        var url = URL.createObjectURL(file);
        img.onload = function () {
          URL.revokeObjectURL(url);
          var maxSide = 1920;
          var w = img.naturalWidth;
          var h = img.naturalHeight;
          if (!w || !h) {
            reject(new Error('Kunde inte läsa bilden.'));
            return;
          }
          var scale = Math.min(1, maxSide / Math.max(w, h));
          var cw = Math.round(w * scale);
          var ch = Math.round(h * scale);
          var canvas = document.createElement('canvas');
          canvas.width = cw;
          canvas.height = ch;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, cw, ch);
          canvas.toBlob(
            function (blob) {
              if (!blob) {
                reject(new Error('Kunde inte bearbeta bilden.'));
                return;
              }
              var name = (file.name || 'bild').replace(/\.[^.]+$/, '') + '.jpg';
              resolve(new File([blob], name, { type: 'image/jpeg' }));
            },
            'image/jpeg',
            0.85
          );
        };
        img.onerror = function () {
          URL.revokeObjectURL(url);
          reject(new Error('Ogiltig bildfil.'));
        };
        img.src = url;
      });
    }

    function uploadToCloudinary(file) {
      var fd = new FormData();
      fd.append('file', file);
      fd.append('upload_preset', cloudinaryPreset);
      return fetch('https://api.cloudinary.com/v1_1/' + encodeURIComponent(cloudinaryCloud) + '/image/upload', {
        method: 'POST',
        body: fd
      }).then(function (res) {
        if (!res.ok) throw new Error('Uppladdning misslyckades.');
        return res.json();
      }).then(function (data) {
        if (!data.secure_url) throw new Error('Uppladdning misslyckades.');
        return data.secure_url;
      });
    }

    function uploadToLitterbox(file) {
      var fd = new FormData();
      fd.append('reqtype', 'fileupload');
      fd.append('time', '72h');
      fd.append('fileToUpload', file, file.name || 'bild.jpg');
      return fetch('https://litterbox.catbox.moe/resources/internals/api.php', {
        method: 'POST',
        body: fd,
        mode: 'cors'
      }).then(function (res) {
        return res.text().then(function (text) {
          var url = (text || '').trim();
          if (!res.ok) {
            throw new Error(url || 'Uppladdning misslyckades (HTTP ' + res.status + ').');
          }
          if (!url || url.indexOf('http') !== 0) {
            throw new Error(url || 'Uppladdning misslyckades.');
          }
          return url;
        });
      });
    }

    function uploadPhotoFile(file) {
      if (cloudinaryCloud && cloudinaryPreset) {
        return uploadToCloudinary(file);
      }
      return uploadToLitterbox(file);
    }

    function getAllPhotoItems() {
      var items = [];
      savedClubs.forEach(function (club) {
        (club.photos || []).forEach(function (photo) {
          items.push(photo);
        });
      });
      pendingPhotos.forEach(function (photo) {
        items.push(photo);
      });
      return items;
    }

    function uploadAllPhotos() {
      var allPhotos = getAllPhotoItems();
      if (!allPhotos.length) return Promise.resolve([]);
      return Promise.all(
        allPhotos.map(function (item) {
          return uploadPhotoFile(item.file);
        })
      );
    }

    function syncPhotoHiddenFields(urls) {
      if (!photosHiddenWrap) return;
      photosHiddenWrap.innerHTML = '';
      (urls || []).forEach(function (url, i) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'contact[Bild ' + (i + 1) + ']';
        input.value = url;
        photosHiddenWrap.appendChild(input);
      });
    }

    function renderPhotoPreviews() {
      if (!photosPreview) return;
      photosPreview.innerHTML = '';
      if (!pendingPhotos.length) {
        photosPreview.hidden = true;
        return;
      }
      photosPreview.hidden = false;
      pendingPhotos.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'golf-valuation__photos-preview-item';
        var img = document.createElement('img');
        img.src = item.previewUrl;
        img.alt = '';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'golf-valuation__photos-remove';
        btn.setAttribute('aria-label', 'Ta bort bild');
        btn.textContent = '×';
        btn.addEventListener('click', function () {
          URL.revokeObjectURL(item.previewUrl);
          pendingPhotos = pendingPhotos.filter(function (p) {
            return p.id !== item.id;
          });
          renderPhotoPreviews();
          if (!hasRequiredPhotos()) {
            showPhotosError(photosRequiredMessage());
            markPhotosSectionError(true);
          } else {
            showPhotosError('');
            markPhotosSectionError(false);
          }
        });
        li.appendChild(img);
        li.appendChild(btn);
        photosPreview.appendChild(li);
      });
    }

    function addPhotoFiles(fileList) {
      if (!fileList || !fileList.length) return;
      showPhotosError('');
      var files = Array.prototype.slice.call(fileList);
      var slots = maxPhotos - pendingPhotos.length;
      if (slots <= 0) {
        showPhotosError('Max ' + maxPhotos + ' bilder.');
        return;
      }
      if (files.length > slots) {
        showPhotosError('Du kan lägga till högst ' + maxPhotos + ' bilder. Endast de första ' + slots + ' lades till.');
        files = files.slice(0, slots);
      }
      files.forEach(function (file) {
        if (!/^image\/(jpeg|png|webp)$/i.test(file.type)) {
          showPhotosError('Endast JPG, PNG och WebP stöds.');
          return;
        }
        if (file.size > maxPhotoBytes) {
          showPhotosError('Varje bild får max vara ' + Math.round(maxPhotoBytes / (1024 * 1024)) + ' MB.');
          return;
        }
        compressImageFile(file)
          .then(function (compressed) {
            if (pendingPhotos.length >= maxPhotos) return;
            pendingPhotos.push({
              id: ++photoIdSeq,
              file: compressed,
              previewUrl: URL.createObjectURL(compressed)
            });
            renderPhotoPreviews();
            if (hasRequiredPhotos()) {
              showPhotosError('');
              markPhotosSectionError(false);
            }
          })
          .catch(function (err) {
            showPhotosError(err.message || 'Kunde inte läsa bilden.');
          });
      });
      if (photosInput) photosInput.value = '';
    }

    if (photosInput) {
      photosInput.addEventListener('change', function () {
        addPhotoFiles(photosInput.files);
      });
    }

    function clearErrorForTarget(e) {
      var t = e.target;
      if (!t || !form.contains(t)) return;
      var field = t.closest('.golf-valuation__field, .golf-valuation__field--full');
      if (field) field.classList.remove('golf-valuation__field--error');
      if (t.matches && t.matches('input, select, textarea')) t.removeAttribute('aria-invalid');
      if (t === typeEl || (typePicker && typePicker.contains(t))) markTypePickerError(false);
      if (photosWrap && photosWrap.contains(t) && hasRequiredPhotos()) {
        markPhotosSectionError(false);
        showPhotosError('');
      }
    }

    form.addEventListener('input', clearErrorForTarget, true);
    form.addEventListener('change', clearErrorForTarget, true);

    function resetModelSelect() {
      if (!modelSelect) return;
      while (modelSelect.options.length > 1) modelSelect.remove(1);
      modelSelect.value = '';
      if (modelCustom) modelCustom.value = '';
      if (modelCustomWrap) modelCustomWrap.hidden = true;
    }

    function syncBrandOtherUi() {
      if (!brandSelect || !brandCustomWrap) return;
      var other = brandSelect.value === '__other__';
      brandCustomWrap.hidden = !other;
      if (!other && brandCustom) brandCustom.value = '';
    }

    function prepareModelStep() {
      if (!brandSelect || !modelSelectWrap || !modelCustomWrap || !modelSelect) return;
      if (brandSelect.value === '__other__') {
        modelSelectWrap.hidden = true;
        modelCustomWrap.hidden = false;
        resetModelSelect();
        return;
      }

      var brandKey = brandSelect.value;
      var clubType = typeEl ? typeEl.value : '';
      var byBrand = MODELS_BY_BRAND_AND_TYPE[brandKey];
      var list = byBrand && clubType && byBrand[clubType] ? byBrand[clubType] : [];

      resetModelSelect();

      if (list.length === 0) {
        modelSelectWrap.hidden = true;
        modelCustomWrap.hidden = false;
        return;
      }

      modelSelectWrap.hidden = false;
      modelCustomWrap.hidden = true;

      list.forEach(function (m) {
        var o = document.createElement('option');
        o.value = m;
        o.textContent = m;
        modelSelect.appendChild(o);
      });

      var oc = document.createElement('option');
      oc.value = '__custom__';
      oc.textContent = 'Annan modell …';
      modelSelect.appendChild(oc);
    }

    function syncModelCustomUi() {
      if (!modelSelect || !modelCustomWrap) return;
      var show = modelSelect.value === '__custom__';
      modelCustomWrap.hidden = !show;
      if (!show && modelCustom) modelCustom.value = '';
    }

    function clearAllFieldErrors() {
      form.querySelectorAll('.golf-valuation__field--error').forEach(function (el) {
        el.classList.remove('golf-valuation__field--error');
      });
      if (photosWrap) photosWrap.classList.remove('golf-valuation__photos--error');
      form.querySelectorAll('[aria-invalid="true"]').forEach(function (el) {
        el.removeAttribute('aria-invalid');
      });
    }

    function markFieldError(el, hasError) {
      if (!el) return;
      var field = el.closest('.golf-valuation__field, .golf-valuation__field--full');
      if (!field) return;
      field.classList.toggle('golf-valuation__field--error', hasError);
      if (el.matches && el.matches('input, select, textarea')) {
        if (hasError) el.setAttribute('aria-invalid', 'true');
        else el.removeAttribute('aria-invalid');
      }
    }

    function markTypePickerError(hasError) {
      var field = typePicker ? typePicker.closest('.golf-valuation__field--full') : null;
      if (field) field.classList.toggle('golf-valuation__field--error', hasError);
    }

    function markPhotosSectionError(hasError) {
      if (photosWrap) photosWrap.classList.toggle('golf-valuation__photos--error', hasError);
    }

    function focusFirstErrorInStep(stepIndex) {
      var pane = wizard && wizard.querySelector('[data-gcv-step="' + stepIndex + '"]');
      if (!pane) return;
      var target =
        pane.querySelector('.golf-valuation__field--error input, .golf-valuation__field--error select, .golf-valuation__field--error textarea') ||
        pane.querySelector('.golf-valuation__field--error .golf-valuation__type-option') ||
        pane.querySelector('.golf-valuation__photos--error .golf-valuation__photos-input') ||
        pane.querySelector('.golf-valuation__payout--error input[type="radio"]');
      if (target && typeof target.focus === 'function') {
        target.focus({ preventScroll: true });
        var scrollTarget = target.closest('.golf-valuation__field--error') || target;
        if (scrollTarget.scrollIntoView) scrollTarget.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }

    function syncTypeFromPicker() {
      if (!typePicker || !typeEl) return;
      var picked = typePicker.querySelector('[data-gcv-type-value][aria-checked="true"]');
      if (picked) {
        var val = picked.getAttribute('data-gcv-type-value');
        if (val) typeEl.value = val;
      }
    }

    function getClubTypeValue() {
      syncTypeFromPicker();
      return typeEl ? typeEl.value : '';
    }

    function persistStep(stepIndex) {
      try {
        sessionStorage.setItem('gcv-step-' + sid, String(stepIndex));
      } catch (e) {}
    }

    function restoreStepAfterLoad() {
      var successFlag = document.getElementById('gcv-form-success-' + sid);
      if (successFlag && successFlag.value === 'true') {
        try {
          sessionStorage.removeItem('gcv-step-' + sid);
        } catch (e) {}
        return 0;
      }
      try {
        var saved = sessionStorage.getItem('gcv-step-' + sid);
        if (saved !== null) {
          var n = parseInt(saved, 10);
          if (!isNaN(n) && n >= 0 && n < TOTAL_STEPS) return n;
        }
      } catch (e) {}
      return 0;
    }

    function isValidEmail(value) {
      if (!value || !value.trim()) return false;
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
    }

    function validateStep(stepIndex, markErrors) {
      var valid = true;

      if (stepIndex === 0) {
        var typeOk = !!getClubTypeValue();
        if (markErrors) markTypePickerError(!typeOk);
        if (!typeOk) valid = false;
      }

      if (stepIndex === 1) {
        var brandOk = !!(brandSelect && brandSelect.value);
        if (markErrors) markFieldError(brandSelect, !brandOk);
        if (!brandOk) valid = false;
        if (brandSelect && brandSelect.value === '__other__') {
          var customBrandOk = !!(brandCustom && brandCustom.value.trim());
          if (markErrors) markFieldError(brandCustom, !customBrandOk);
          if (!customBrandOk) valid = false;
        }
      }

      if (stepIndex === 2) {
        if (brandSelect && brandSelect.value === '__other__') {
          var otherModelOk = !!(modelCustom && modelCustom.value.trim());
          if (markErrors) markFieldError(modelCustom, !otherModelOk);
          if (!otherModelOk) valid = false;
        } else if (modelSelectWrap && modelSelectWrap.hidden) {
          var hiddenModelOk = !!(modelCustom && modelCustom.value.trim());
          if (markErrors) markFieldError(modelCustom, !hiddenModelOk);
          if (!hiddenModelOk) valid = false;
        } else {
          var modelOk = !!(modelSelect && modelSelect.value);
          if (markErrors) markFieldError(modelSelect, !modelOk);
          if (!modelOk) valid = false;
          if (modelSelect && modelSelect.value === '__custom__') {
            var customModelOk = !!(modelCustom && modelCustom.value.trim());
            if (markErrors) markFieldError(modelCustom, !customModelOk);
            if (!customModelOk) valid = false;
          }
        }
      }

      if (stepIndex === 3) {
        var handednessOk = !!(handednessEl && handednessEl.value);
        if (markErrors) markFieldError(handednessEl, !handednessOk);
        if (!handednessOk) valid = false;

        if (showsHeadcoverQuestion()) {
          var headcoverOk = !!(headcoverEl && headcoverEl.value);
          if (markErrors) markFieldError(headcoverEl, !headcoverOk);
          if (!headcoverOk) valid = false;
        } else {
          markFieldError(headcoverEl, false);
        }

        if (!isPutterType()) {
          var shaftOk = !!(shaftEl && shaftEl.value);
          if (markErrors) markFieldError(shaftEl, !shaftOk);
          if (!shaftOk) valid = false;

          var flexOk = !!(flexEl && flexEl.value);
          if (markErrors) markFieldError(flexEl, !flexOk);
          if (!flexOk) valid = false;
        }
      }

      if (stepIndex === 4) {
        var conditionOk = !!(conditionEl && conditionEl.value);
        if (markErrors) markFieldError(conditionEl, !conditionOk);
        if (!conditionOk) valid = false;
      }

      if (stepIndex === 5) {
        var nameOk = !!(nameEl && nameEl.value.trim());
        if (markErrors) markFieldError(nameEl, !nameOk);
        if (!nameOk) valid = false;

        var emailOk = isValidEmail(emailEl ? emailEl.value : '');
        if (markErrors) markFieldError(emailEl, !emailOk);
        if (!emailOk) valid = false;

        var photosOk = minPhotos <= 0 || hasRequiredPhotos();
        if (markErrors) {
          markPhotosSectionError(!photosOk);
          if (!photosOk) showPhotosError(photosRequiredMessage());
          else showPhotosError('');
        }
        if (!photosOk) valid = false;

        if (requiresPayoutChoice()) {
          var payoutOk = !!getSelectedPayout();
          if (markErrors) markPayoutError(!payoutOk);
          if (!payoutOk) {
            valid = false;
          } else if (!validatePayoutDetails(markErrors)) {
            valid = false;
          }
        }
      }

      return valid;
    }

    function runSubmitValidation() {
      syncTypeFromPicker();
      clearAllFieldErrors();

      if (currentStep !== TOTAL_STEPS - 1) {
        if (!validateStep(currentStep, true)) {
          focusFirstErrorInStep(currentStep);
          return false;
        }
        return true;
      }

      if (!validateStep(5, true)) {
        showStep(5, true);
        focusFirstErrorInStep(5);
        return false;
      }

      return true;
    }

    function showStep(n, skipAutoFocus) {
      currentStep = n;
      persistStep(n);
      steps.forEach(function (el) {
        var i = parseInt(el.getAttribute('data-gcv-step'), 10);
        el.hidden = i !== n;
      });
      if (progressEl) updateProgressLabel(n);
      if (backBtn) backBtn.hidden = n === 0;
      if (nextBtn) nextBtn.hidden = n === TOTAL_STEPS - 1;
      if (submitBtn) submitBtn.hidden = n !== TOTAL_STEPS - 1;
      if (n === TOTAL_STEPS - 1 && window.GolfVardering && window.GolfVardering.invalidateEstimateIfStale) {
        window.GolfVardering.invalidateEstimateIfStale(form);
      }
      syncCheckoutUi();
      renderClubsCart();
      if (n === 3) {
        rebuildLoftOptions();
        syncPutterSpecsUi();
      }
      if (skipAutoFocus) return;
      requestAnimationFrame(function () {
        var pane = wizard && wizard.querySelector('[data-gcv-step="' + n + '"]');
        if (!pane) return;
        var fe;
        if (n === 0) {
          fe = pane.querySelector('.golf-valuation__type-option');
        } else if (n === 5) {
          fe = pane.querySelector('#gcv-name-' + sid) || pane.querySelector('input, textarea');
        } else if (n === 3) {
          fe = pane.querySelector('label:not([hidden]) select, label:not([hidden]) input:not([type="hidden"])');
        } else {
          fe = pane.querySelector('select:not(.golf-valuation__type-select), input:not([type="hidden"]), textarea');
        }
        if (fe && typeof fe.focus === 'function') fe.focus();
      });
    }

    function syncTypePickerUi() {
      if (!typeEl) return;
      var selected = typeEl.value;
      typeOptions.forEach(function (btn) {
        var isSelected = btn.getAttribute('data-gcv-type-value') === selected;
        btn.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        btn.classList.toggle('is-selected', isSelected);
      });
    }

    function setClubType(value) {
      if (!typeEl) return;
      typeEl.value = value;
      syncTypePickerUi();
      typeEl.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (typePicker) {
      typePicker.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-gcv-type-value]');
        if (!btn) return;
        setClubType(btn.getAttribute('data-gcv-type-value'));
      });
    }

    if (typeEl) {
      typeEl.addEventListener('change', function () {
        syncTypePickerUi();
        rebuildLoftOptions();
        syncPutterSpecsUi();
      });
    }

    if (loftSelect) {
      loftSelect.addEventListener('change', syncLoftCustomUi);
    }

    if (brandSelect) {
      brandSelect.addEventListener('change', function () {
        syncBrandOtherUi();
        resetModelSelect();
      });
    }

    if (modelSelect) {
      modelSelect.addEventListener('change', syncModelCustomUi);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (!validateStep(currentStep, true)) {
          focusFirstErrorInStep(currentStep);
          return;
        }
        if (currentStep === 1) prepareModelStep();
        if (currentStep < TOTAL_STEPS - 1) showStep(currentStep + 1);
      });
    }

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        if (currentStep > 0) showStep(currentStep - 1);
      });
    }

    function proceedWithSend() {
      if (isSubmitting) return;

      isSubmitting = true;
      showPhotosError('');
      var submitLabel = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = getAllPhotoItems().length ? 'Laddar upp bilder …' : 'Skickar …';
      }

      uploadAllPhotos()
        .then(function (urls) {
          syncPhotoHiddenFields(urls);
          if (bodyHidden) bodyHidden.value = buildBody(urls);
          try {
            sessionStorage.removeItem('gcv-step-' + sid);
          } catch (e) {}
          form.dataset.gcvNativeSubmit = '1';
          form.submit();
        })
        .catch(function (err) {
          markPhotosSectionError(true);
          showPhotosError(
            (err && err.message && err.message.indexOf('http') !== 0
              ? err.message
              : null) ||
              'Bilderna kunde inte laddas upp. Försök igen. Kontakta oss om problemet kvarstår.'
          );
          isSubmitting = false;
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitLabel;
          }
        });
    }

    function handleSend() {
      if (isSubmitting) return;

      if (!runSubmitValidation()) return;

      var aiEnabled =
        root.dataset.gcvAiEnabled === 'true' &&
        root.dataset.gcvAiApi &&
        window.GolfVardering;

      if (aiEnabled) {
        window.GolfVardering.ensureEstimate(form, proceedWithSend, function () {});
        return;
      }

      proceedWithSend();
    }

    form.addEventListener('submit', function (e) {
      if (form.dataset.gcvNativeSubmit === '1') {
        form.dataset.gcvNativeSubmit = '';
        return;
      }
      e.preventDefault();
      handleSend();
    });

    if (submitBtn) {
      submitBtn.addEventListener('click', handleSend);
    }

    if (addClubBtn) {
      addClubBtn.addEventListener('click', handleAddAnotherClub);
    }

    if (finishClubsBtn) {
      finishClubsBtn.addEventListener('click', finalizeCheckout);
    }

      syncBrandOtherUi();
      syncTypePickerUi();
      rebuildLoftOptions();
      syncPutterSpecsUi();
      showStep(restoreStepAfterLoad(), true);
    }

    document.querySelectorAll('.golf-valuation[data-gcv-sid]').forEach(initGolfValuationSection);
  })();

  (function () {
    'use strict';

    var defaultApiUrl = 'https://cursor-formulaer.vercel.app/api/vardera';

    var defaultFieldSelectors = {
      modell: null,
      typ: '[data-valuation="type"], #gcv-type-[sid]',
      dexteritet: '[data-valuation="dexteritet"]',
      loft: '[data-valuation="loft"]',
      flex: '[data-valuation="flex"]',
      huvud: '[data-valuation="huvud"]',
      skick: '[data-valuation="condition"]',
      info: '[data-valuation="info"]'
    };

    var instances = new WeakMap();

    function qs(root, selector) {
      if (!selector) return null;
      return root.querySelector(selector);
    }

    function readSelectText(el) {
      if (!el || el.tagName !== 'SELECT') return '';
      var opt = el.options[el.selectedIndex];
      return opt ? opt.textContent.trim() : '';
    }

    function readValue(el) {
      if (!el) return '';
      if (el.tagName === 'SELECT') return readSelectText(el);
      return (el.value || '').trim();
    }

    function resolveSid(root) {
      var host = root.closest('[data-gcv-sid]');
      return host ? host.getAttribute('data-gcv-sid') : '';
    }

    function selectorForSid(selector, sid) {
      if (!selector || !sid) return selector;
      return selector.replace(/\[sid\]/g, sid);
    }

    function mapConditionToAi(skickText, skickValue) {
      var v = (skickValue || '').toLowerCase();
      if (!v) return '—';
      if (v === 'mint') return 'Utmärkt';
      if (v === 'good') return 'Bra';
      if (v === 'fair') return 'Tillfredsställande';
      if (v === 'poor') return 'Tillfredsställande';
      var t = (skickText || '').toLowerCase();
      if (t.indexOf('nästan ny') !== -1 || t.indexOf('mycket bra') !== -1) return 'Utmärkt';
      if (t.indexOf('bra') !== -1) return 'Bra';
      return skickText || '—';
    }

    function mapDexteritet(value, text) {
      if (!value) return '—';
      var v = value.toLowerCase();
      if (v === 'left' || (text && text.toLowerCase().indexOf('vänster') !== -1)) return 'Vänsterhänt';
      if (v === 'right' || (text && text.toLowerCase().indexOf('höger') !== -1)) return 'Högerhänt';
      return text || '—';
    }

    function mapHuvud(value, text) {
      if (!value) return '—';
      var v = value.toLowerCase();
      var t = (text || '').toLowerCase();
      if (v === 'no' || v === 'nej' || t === 'nej' || t.indexOf('saknar') !== -1) {
        return 'Nej';
      }
      return 'Ja';
    }

    function mapFlex(value, text) {
      var map = {
        extra_stiff: 'X-Stiff',
        stiff: 'Stiff',
        regular: 'Regular',
        wedge: 'Wedge',
        senior: 'Senior',
        ladies: 'Ladies',
        unknown: 'Okänt'
      };
      if (!value) return '—';
      if (map[value]) return map[value];
      return text || '—';
    }

    function collectModell(form, sid) {
      var brandEl = form.querySelector('#gcv-brand-select-' + sid);
      var brandCustom = form.querySelector('#gcv-brand-custom-' + sid);
      var modelEl = form.querySelector('#gcv-model-select-' + sid);
      var modelCustom = form.querySelector('#gcv-model-custom-' + sid);

      var brand = '';
      if (brandEl && brandEl.value === '__other__' && brandCustom) {
        brand = readValue(brandCustom);
      } else if (brandEl) {
        brand = readSelectText(brandEl) || brandEl.value;
      }

      var model = '';
      if (modelCustom && !modelCustom.closest('[hidden]')) {
        model = readValue(modelCustom);
      } else if (modelEl && modelEl.value === '__other__' && modelCustom) {
        model = readValue(modelCustom);
      } else if (modelEl) {
        model = readSelectText(modelEl) || modelEl.value;
      }

      return [brand, model].filter(Boolean).join(' ').trim();
    }

    function collectLoft(form, sid) {
      var loftSelect = form.querySelector('#gcv-loft-select-' + sid);
      var loftCustom = form.querySelector('#gcv-loft-custom-' + sid);
      if (loftCustom && !loftCustom.closest('[hidden]') && loftCustom.value.trim()) {
        return readValue(loftCustom);
      }
      if (loftSelect) {
        var t = readSelectText(loftSelect);
        if (t && t !== 'Välj …' && t !== 'Välj … (valfritt)') return t;
      }
      return '—';
    }

    function isManualModelEntry(form, sid) {
      var brandEl = form.querySelector('#gcv-brand-select-' + sid);
      var modelEl = form.querySelector('#gcv-model-select-' + sid);
      var modelCustom = form.querySelector('#gcv-model-custom-' + sid);
      var modelSelectWrap = form.querySelector('#gcv-model-select-wrap-' + sid);
      if (brandEl && brandEl.value === '__other__') return true;
      if (modelEl && modelEl.value === '__custom__') return true;
      if (modelSelectWrap && modelSelectWrap.hidden && modelCustom && modelCustom.value.trim()) {
        return true;
      }
      if (modelCustom && !modelCustom.closest('[hidden]') && modelCustom.value.trim()) {
        return true;
      }
      return false;
    }

    function collectPayload(form, config) {
      var sid = config.sid || resolveSid(form);
      var sel = config.fieldSelectors || defaultFieldSelectors;

      var typeEl = qs(form, selectorForSid(sel.typ, sid)) || form.querySelector('#gcv-type-' + sid);
      var flexEl = qs(form, selectorForSid(sel.flex, sid));
      var skickEl = qs(form, selectorForSid(sel.skick, sid));
      var dexEl = qs(form, selectorForSid(sel.dexteritet, sid));
      var huvudEl = qs(form, selectorForSid(sel.huvud, sid));
      var shaftEl = form.querySelector('#gcv-shaft-' + sid);

      var modell = sel.modell ? readValue(qs(form, selectorForSid(sel.modell, sid))) : collectModell(form, sid);
      var typ = readSelectText(typeEl) || readValue(typeEl);
      var isPutter = typeEl && typeEl.value === 'putter';
      var typeValue = typeEl ? typeEl.value : '';
      var skipHeadcover =
        typeValue === 'iron' ||
        typeValue === 'iron_set' ||
        typeValue === 'wedge' ||
        typeValue === 'wedge_set';
      var manualModel = isManualModelEntry(form, sid);
      var flex = isPutter ? 'Okänt' : mapFlex(flexEl ? flexEl.value : '', readSelectText(flexEl));
      var skick = mapConditionToAi(readSelectText(skickEl), skickEl ? skickEl.value : '');
      var dexteritet = mapDexteritet(dexEl ? dexEl.value : '', readSelectText(dexEl));
      var huvud = skipHeadcover
        ? '—'
        : mapHuvud(huvudEl ? huvudEl.value : '', readSelectText(huvudEl));
      var loft = isPutter ? '—' : collectLoft(form, sid);
      var skaft = isPutter ? '—' : shaftEl && shaftEl.value ? readSelectText(shaftEl) : '—';
      var infoParts = [];
      if (!isPutter && shaftEl && shaftEl.value) infoParts.push('Skaft: ' + readSelectText(shaftEl));

      return {
        modell: modell,
        typ: typ,
        dexteritet: dexteritet,
        loft: loft,
        flex: flex,
        skaft: skaft,
        huvud: huvud,
        skick: skick,
        manuell_modell: manualModel,
        info: infoParts.join('. ') || '—'
      };
    }

    function formatPrice(sek) {
      return new Intl.NumberFormat('sv-SE', {
        style: 'currency',
        currency: 'SEK',
        maximumFractionDigits: 0
      }).format(sek);
    }

    function getResultEl(form, config) {
      var sid = config.sid || resolveSid(form);
      var id = config.resultId || (sid ? 'gcv-ai-estimate-' + sid : null);
      if (!id) return null;
      return document.getElementById(id);
    }

    function setLoading(el, isLoading) {
      if (!el) return;
      el.hidden = false;
      el.classList.toggle('golf-valuation__ai--loading', isLoading);
      if (isLoading) {
        el.innerHTML =
          '<p class="golf-valuation__ai-status" role="status">' +
          '<span class="golf-valuation__ai-spinner" aria-hidden="true"></span>' +
          'Beräknar prisförslag …</p>';
      }
    }

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function renderResult(el, data, config) {
      if (!el) return;

      if (data.okand_modell || data.pris === null || data.pris === undefined) {
        renderError(
          el,
          (data.motivering && String(data.motivering).trim()) ||
            'Den här modellen kan vi tyvärr inte ge ett automatiskt prisförslag för. Välj en modell i listan eller kontakta oss så hjälper vi dig.'
        );
        return;
      }

      var FREE_SHIPPING_THRESHOLD = 1000;
      var SHIPPING_COST = 49;
      var basePrice = Math.round(data.pris);
      var isFreeShipping = basePrice >= FREE_SHIPPING_THRESHOLD;
      var netPrice = isFreeShipping ? basePrice : Math.max(0, basePrice - SHIPPING_COST);
      var creditPrice = Math.round(netPrice * 1.2);
      var cashDesc = isFreeShipping
        ? 'Swish eller banköverföring — välj nedan'
        : '49 kr har dragits av för frakt';

      el.hidden = false;
      el.classList.remove('golf-valuation__ai--loading');
      el.innerHTML =
        '<div class="golf-valuation__ai-card">' +
        '<div class="golf-valuation__ai-offers">' +
        '<div class="golf-valuation__ai-offer golf-valuation__ai-offer--cash">' +
        '<p class="golf-valuation__ai-offer-label">Utbetalning</p>' +
        '<p class="golf-valuation__ai-offer-price">Cirka ' +
        formatPrice(netPrice) +
        '</p>' +
        '<p class="golf-valuation__ai-offer-desc">' +
        cashDesc +
        '</p>' +
        '</div>' +
        '<div class="golf-valuation__ai-offer golf-valuation__ai-offer--credit">' +
        '<p class="golf-valuation__ai-offer-label">Butikskredit · 20% bonus</p>' +
        '<p class="golf-valuation__ai-offer-price">Cirka ' +
        formatPrice(creditPrice) +
        '</p>' +
        '<p class="golf-valuation__ai-offer-desc">Att handla för i butiken</p>' +
        '</div>' +
        '</div>' +
        '<p class="golf-valuation__ai-hint" id="gcv-ai-hint-' +
        config.sid +
        '">' +
        'Välj utbetalningsmetod nedan och klicka sedan «Slutför och skicka in».' +
        '</p>' +
        '</div>';

      el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

      document.dispatchEvent(
        new CustomEvent('gcv-estimate-ready', {
          detail: { sid: config.sid, pris: data.pris }
        })
      );
    }

    function renderError(el, message) {
      if (!el) return;
      el.hidden = false;
      el.classList.remove('golf-valuation__ai--loading');
      el.innerHTML =
        '<p class="golf-valuation__ai-error" role="alert">' + escapeHtml(message) + '</p>';
    }

    function fetchEstimate(apiUrl, payload) {
      return fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        mode: 'cors'
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            if (res.status === 403) {
              throw new Error(
                'Butiksdomänen är inte tillåten att anropa värderingstjänsten. Kontakta oss om felet kvarstår.'
              );
            }
            throw new Error(data.error || data.detail || 'Kunde inte hämta prisförslag.');
          }
          return data;
        });
      });
    }

    function createInstance(form, config) {
      var state = {
        estimateShown: false,
        lastPayloadKey: '',
        lastResult: null,
        fetching: false
      };

      function payloadKey(payload) {
        return JSON.stringify(payload);
      }

      function storeResultOnForm(result) {
        form.dataset.gcvAiEstimate =
          formatPrice(result.pris) + ' — ' + result.motivering;
        form.dataset.gcvAiPrice = String(result.pris);
      }

      function requestEstimate(onSuccess, onError) {
        var apiUrl = config.apiUrl;
        if (!apiUrl || apiUrl.indexOf('DITT-PROJEKT') !== -1) {
          onError('AI-värdering är inte konfigurerad. Ange Vercel-URL i temat.');
          return;
        }

        var payload = collectPayload(form, config);
        if (!payload.modell || !payload.typ) {
          onError('Fyll i märke och modell innan prisförslag kan beräknas.');
          return;
        }

        if (payload.manuell_modell) {
          var unknownMsg =
            'Den här modellen kan vi tyvärr inte ge ett automatiskt prisförslag för. Välj en modell i listan eller kontakta oss så hjälper vi dig.';
          renderError(getResultEl(form, config), unknownMsg);
          onError(unknownMsg);
          return;
        }

        var key = payloadKey(payload);
        var resultEl = getResultEl(form, config);

        invalidateEstimateIfStale();
        key = payloadKey(collectPayload(form, config));

        if (state.estimateShown && state.lastPayloadKey === key && state.lastResult) {
          onSuccess(state.lastResult);
          return;
        }

        state.fetching = true;
        setLoading(resultEl, true);

        fetchEstimate(apiUrl, payload)
          .then(function (data) {
            state.fetching = false;
            if (data.okand_modell || data.pris === null || data.pris === undefined) {
              state.estimateShown = false;
              state.lastPayloadKey = '';
              state.lastResult = null;
              delete form.dataset.gcvAiEstimate;
              delete form.dataset.gcvAiPrice;
              var msg =
                (data.motivering && String(data.motivering).trim()) ||
                'Den här modellen kan vi tyvärr inte ge ett automatiskt prisförslag för. Välj en modell i listan eller kontakta oss så hjälper vi dig.';
              renderError(resultEl, msg);
              onError(msg);
              return;
            }
            state.estimateShown = true;
            state.lastPayloadKey = key;
            state.lastResult = data;
            storeResultOnForm(data);
            renderResult(resultEl, data, config);
            onSuccess(data);
          })
          .catch(function (err) {
            state.fetching = false;
            var msg = (err && err.message) || 'Något gick fel vid prisberäkningen. Försök igen.';
            if (/failed to fetch|couldn.?t fetch|networkerror|load failed/i.test(msg)) {
              msg =
                'Kunde inte nå värderingstjänsten. Kontrollera att du är på golffynd1.se och försök igen om en stund.';
            }
            renderError(resultEl, msg);
            onError(msg);
          });
      }

      function resetEstimate() {
        state.estimateShown = false;
        state.lastPayloadKey = '';
        state.lastResult = null;
        delete form.dataset.gcvAiEstimate;
        delete form.dataset.gcvAiPrice;
        var resultEl = getResultEl(form, config);
        if (resultEl) {
          resultEl.hidden = true;
          resultEl.innerHTML = '';
        }
        document.dispatchEvent(
          new CustomEvent('gcv-estimate-reset', {
            detail: { sid: config.sid }
          })
        );
      }

      function hasStoredEstimate() {
        return state.estimateShown || !!form.dataset.gcvAiPrice;
      }

      function invalidateEstimateIfStale() {
        if (!hasStoredEstimate()) return false;
        var key = payloadKey(collectPayload(form, config));
        if (!state.lastPayloadKey || state.lastPayloadKey !== key) {
          resetEstimate();
          return true;
        }
        return false;
      }

      function onClubSpecChange() {
        if (hasStoredEstimate()) resetEstimate();
      }

      function isClubSpecField(el) {
        if (!el || !config.sid) return false;
        if (el.closest('[data-valuation]')) return true;
        if (el.closest('#gcv-type-picker-' + config.sid)) return true;
        var id = el.id || '';
        return (
          id === 'gcv-brand-select-' + config.sid ||
          id === 'gcv-brand-custom-' + config.sid ||
          id === 'gcv-model-select-' + config.sid ||
          id === 'gcv-model-custom-' + config.sid ||
          id === 'gcv-loft-custom-' + config.sid
        );
      }

      function ensureEstimate(onProceed, onAbort) {
        if (!config.enabled) {
          onProceed();
          return;
        }

        if (state.fetching) {
          if (onAbort) onAbort();
          return;
        }

        invalidateEstimateIfStale();

        var payload = collectPayload(form, config);
        var key = payloadKey(payload);

        if (state.estimateShown && state.lastPayloadKey === key) {
          onProceed();
          return;
        }

        requestEstimate(
          function () {
            if (onAbort) onAbort();
          },
          function () {
            if (onAbort) onAbort();
          }
        );
      }

      form.addEventListener(
        'change',
        function (e) {
          if (!isClubSpecField(e.target)) return;
          onClubSpecChange();
        },
        true
      );

      form.addEventListener(
        'input',
        function (e) {
          if (!isClubSpecField(e.target)) return;
          onClubSpecChange();
        },
        true
      );

      return {
        ensureEstimate: ensureEstimate,
        resetEstimate: resetEstimate,
        invalidateEstimateIfStale: invalidateEstimateIfStale,
        collectPayload: function () {
          return collectPayload(form, config);
        }
      };
    }

    function init(userConfig) {
      var config = userConfig || {};
      var form =
        typeof config.form === 'string'
          ? document.querySelector(config.form)
          : config.form;

      if (!form) return null;

      var root = form.closest('.golf-valuation') || form;
      var sid = config.sid || resolveSid(root);

      var fullConfig = {
        enabled: config.enabled !== false,
        apiUrl:
          config.apiUrl ||
          root.getAttribute('data-gcv-ai-api') ||
          defaultApiUrl,
        sid: sid,
        resultId: config.resultId || (sid ? 'gcv-ai-estimate-' + sid : 'gcv-ai-estimate'),
        fieldSelectors: Object.assign({}, defaultFieldSelectors, config.fieldSelectors || {}),
        confirmHint: config.confirmHint
      };

      var instance = createInstance(form, fullConfig);
      instances.set(form, instance);
      return instance;
    }

    function initFromDom() {
      document.querySelectorAll('.golf-valuation[data-gcv-sid]').forEach(function (root) {
        var sid = root.getAttribute('data-gcv-sid');
        var form = document.getElementById('GolfValuation-' + sid);
        if (!form) return;

        init({
          form: form,
          sid: sid,
          enabled: root.getAttribute('data-gcv-ai-enabled') !== 'false',
          apiUrl: root.getAttribute('data-gcv-ai-api') || defaultApiUrl
        });
      });
    }

    window.GolfVardering = {
      init: init,
      initFromDom: initFromDom,
      ensureEstimate: function (form, onProceed, onAbort) {
        var inst = instances.get(form);
        if (!inst) {
          onProceed();
          return;
        }
        inst.ensureEstimate(onProceed, onAbort);
      },
      resetEstimate: function (form) {
        var inst = instances.get(form);
        if (inst) inst.resetEstimate();
      },
      invalidateEstimateIfStale: function (form) {
        var inst = instances.get(form);
        if (inst) return inst.invalidateEstimateIfStale();
        return false;
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFromDom);
    } else {
      initFromDom();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
